const config = require("../config.js");
const UTILS = require("./utils.js");
const vA775 = ["aHolder", "aMerger", "aContainer", "krunkerio_728x90_1", "/21823819281/frvr-krunker_io-krunker-display-banner-krunkerio_728x90_1", "/21823819281/frvr-frvr-krunker-display-banner-krunkerio_728x90_1", "mapVote", "mapVoteD", "mapVoteU", "modVoteHold", "modVoteD", "modVoteU", "modVote", "mapInfoHolder", "tDecCheck", "tSubCheck", "tSubOffer", "tHeader0", "tHeader1", "tradeReady0", "tradeReady1", "tSubName", "tradeChatHolder", "tradeChatList", "tradeChatItem", "tradeTotal", "trd_", "offerVal", "trd_inv_", "tItemN", "tItemCnt", "tItemImg", "tItemSprayImg", "tItemHolder", "tSubHolder", "tDecOffer", "tradeList0", "tradeList1", "offerVal0", "offerVal1", "estOfferVal", "tDecName", "tTotal", "tListN", "tHolderR", "tHolderL", "invList1", "tList", "invList0", "jumpSIMG", "jumpSVID", "jumpSVIDHolder", "material-icons", "vote", "ot-sdk-btn-floating", "interactMsg", "signedInHeaderBar", "signedOutHeaderBar", "accName", "accPass", "accResp", "referralHeader"];
const vA776 = ["menuWindow"];
const vA777 = ["pass", "login", "user", "register", "signin"];
module.exports = function (p17040, p17041, p17042, p17043, p17044, game, RENDER, p17047, p17048) {
  function f2121(p17049) {
    return !!vO441[p17049] || (vO441[p17049] = 1, false);
  }
  function f2122(p17050) {
    if (vO441[p17050]) {
      vO441[p17050] = null;
      delete vO441[p17050];
    }
  }
  function f2123(p17051, p17052) {
    if (!vO442[p17051]) {
      vO442[p17051] = 0;
    }
    vO442[p17051]++;
    return vO442[p17051] >= p17052;
  }
  function f2124(p17053, p17054) {
    if (!vO443[p17053]) {
      vO443[p17053] = 0;
    }
    vO443[p17053]++;
    return vO443[p17053] > p17054;
  }
  function f2125(...iÎìîîíi) {
    p17041.error(iÎìîîíi.map(p17055 => p17040.sanitize(p17055)));
  }
  const v13689 = (p17040 || {}).addPrefix;
  var v13690;
  var v13691;
  var v13692;
  var v13693;
  var vA778 = [];
  var vO441 = {};
  var vO442 = {};
  if (arguments.length) {
    setInterval(function () {
      vO442 = {};
    }, 1000);
  }
  var vO443 = {};
  if (arguments.length) {
    setInterval(function () {
      vO443 = {};
    }, 10000);
  }
  const vO444 = {
    player: function (p17056) {
      return p17056._protected ||= {
        get id() {
          return p17056.id;
        },
        get sid() {
          return p17056.sid;
        },
        get username() {
          return p17056.name;
        },
        get isYou() {
          return p17056.isYou;
        },
        get active() {
          return !!p17056.active;
        },
        get accountID() {
          if (p17043) {
            if (p17056.account) {
              return p17056.account.id || "";
            } else {
              return "";
            }
          } else {
            return "";
          }
        },
        get accountName() {
          if (p17043) {
            if (p17056.account) {
              return p17056.account.name || "";
            } else {
              return "";
            }
          } else {
            return "";
          }
        },
        disableDefault: function (p17057) {
          if (p17057 == "mouseY" || p17057 == "mouseX" || p17057 == "movDir" || p17057 == "lMouse" || p17057 == "rMouse" || p17057 == "jump" || p17057 == "reload" || p17057 == "crouch" || p17057 == "scroll" || p17057 == "swap" || p17057 == "restK" || p17057 == "inter") {
            p17056.disabledInputs[p17057] = 1;
          }
        },
        get defaultMovement() {
          return !!p17056.defaultMovement;
        },
        set defaultMovement(p17058) {
          p17056.defaultMovement = !!p17058;
        },
        get defaultVelocity() {
          return !!p17056.defaultVelocity;
        },
        set defaultVelocity(p17059) {
          p17056.defaultVelocity = !!p17059;
        },
        get defaultRotation() {
          return !!p17056.defaultRotation;
        },
        set defaultRotation(p17060) {
          p17056.defaultRotation = !!p17060;
        },
        get disableShooting() {
          return !!p17056.disableShooting;
        },
        set disableShooting(p17061) {
          p17056.disableShooting = !!p17061;
        },
        get disableMelee() {
          return !!p17056.disableMelee;
        },
        set disableMelee(p17062) {
          p17056.disableMelee = !!p17062;
        },
        get visible() {
          return !!p17056.objInstances && !!p17056.objInstances.visible;
        },
        set visible(p17063) {
          if (p17056.objInstances) {
            p17056.objInstances.visible = !!p17063;
          }
        },
        get inView() {
          return !!p17056.inView;
        },
        get assetID() {
          if (p17056.config) {
            return p17056.config.aID || "";
          } else {
            return "";
          }
        },
        set assetID(p17064) {
          if (game) {
            game.players.updateAssetID(p17056, p17064);
          }
        },
        getAsset: function () {
          if (p17056.meshRef && p17056.meshRef.children[0]) {
            return vO444.obj3D(p17056.meshRef.children[0]);
          } else {
            return undefined;
          }
        },
        get onWall() {
          return !!p17056.onWall;
        },
        set onWall(p17065) {
          p17056.onWall = !!p17065;
        },
        get onGround() {
          return !!p17056.onGround || !!p17056.onRamp;
        },
        set onGround(p17066) {
          p17056.onGround = !!p17066;
        },
        get onTerrain() {
          return !!p17056.onTerrain;
        },
        set onTerrain(p17067) {
          p17056.onTerrain = !!p17067;
        },
        get isCrouching() {
          return !!((p17056.crouchVal || 0) >= 1);
        },
        set isCrouching(p17068) {
          p17056.crouchVal = ~~!!p17068;
        },
        get team() {
          return p17056.team || 0;
        },
        get classIndex() {
          return p17056.classIndex || 0;
        },
        set classIndex(p17069) {
          if (game && p17043 && p17044) {
            var v13694 = parseInt(p17069) || 0;
            if (game.classes[v13694] && p17056.classIndex != v13694) {
              p17056.classIndex = v13694;
              p17056.updateItems(game, p17044, true);
            }
          }
        },
        get loadoutIndex() {
          return p17056.loadoutIndex || 0;
        },
        set loadoutIndex(p17070) {
          if (game && p17043 && p17044) {
            var v13695 = parseInt(p17070) || 0;
            if (p17056.loadout[v13695] != null) {
              game.players.swapWeapon(p17056, 0, true, undefined, v13695);
            }
          }
        },
        get ammo() {
          return p17056.ammos[p17056.loadoutIndex] || 0;
        },
        changePrimary: function (p17071) {
          if (game && p17043 && p17044) {
            var vParseInt50 = parseInt(p17071 || 0);
            if (game.weaponConfig[vParseInt50]) {
              var v13696 = game.weaponConfig[vParseInt50];
              if (!v13696.secondary && !v13696.melee && !v13696.equipment) {
                var v13697;
                var v13698 = false;
                for (var vLN02512 = 0; vLN02512 < p17056.loadout.length; vLN02512++) {
                  v13697 = game.weaponConfig[p17056.loadout[vLN02512]];
                  if (!v13697.secondary && !v13697.melee && !v13697.equipment) {
                    if (v13697.id == v13696.id) {
                      return;
                    }
                    p17056.loadout[vLN02512] = v13696.id;
                    v13698 = true;
                    break;
                  }
                }
                var v13699 = p17056.loadout.indexOf(12) == -1;
                if (!v13698) {
                  p17056.loadout.splice(0, 0, v13696.id);
                }
                p17056.updateLoadout(game, p17056.loadoutIndex, true, p17056.loadout, undefined, undefined, undefined, v13699);
                game.broadcast("inat", p17056.sid, p17056.loadout, p17056.loadoutIndex, undefined, undefined, false, true, undefined, undefined, undefined, undefined, v13699);
              }
            }
          }
        },
        changeSecondary: function (p17072) {
          if (game && p17043 && p17044) {
            var vParseInt51 = parseInt(p17072 || 0);
            if (game.weaponConfig[vParseInt51]) {
              var v13700 = game.weaponConfig[vParseInt51];
              if (!!v13700.secondary && !v13700.equipment && !v13700.melee) {
                var v13701;
                var v13702 = false;
                for (var vLN02513 = 0; vLN02513 < p17056.loadout.length; vLN02513++) {
                  v13701 = game.weaponConfig[p17056.loadout[vLN02513]];
                  if (v13701.secondary) {
                    if (v13701.id == v13700.id) {
                      return;
                    }
                    p17056.loadout[vLN02513] = v13700.id;
                    v13702 = true;
                    break;
                  }
                }
                var v13703 = p17056.loadout.indexOf(12) == -1;
                if (!v13702) {
                  p17056.loadout.splice(p17056.loadout.length > 1 ? 1 : 0, 0, v13700.id);
                }
                p17056.updateLoadout(game, p17056.loadoutIndex, true, p17056.loadout, undefined, undefined, undefined, v13703);
                game.broadcast("inat", p17056.sid, p17056.loadout, p17056.loadoutIndex, undefined, undefined, false, true, undefined, undefined, undefined, undefined, v13703);
              }
            }
          }
        },
        giveWeapon: function (p17073) {
          if (game && p17043 && p17044) {
            var vParseInt52 = parseInt(p17073 || 0);
            if (game.weaponConfig[vParseInt52]) {
              var v13704 = game.weaponConfig[vParseInt52];
              if (!v13704.equipment) {
                var v13705;
                var v13706 = !v13704.secondary && !v13704.melee && !v13704.equipment;
                var v13707 = !!v13704.secondary;
                var v13708 = v13704.melee;
                var v13709 = -1;
                var v13710 = -1;
                var v13711 = -1;
                var vUndefined11 = undefined;
                for (var vLN02514 = 0; vLN02514 < p17056.loadout.length; vLN02514++) {
                  v13705 = game.weaponConfig[p17056.loadout[vLN02514]];
                  if (v13705.id == v13704.id) {
                    return;
                  }
                  if (v13705.secondary || v13705.melee || v13705.equipment) {
                    if (v13705.secondary) {
                      v13710 = vLN02514;
                    } else if (v13705.melee) {
                      v13711 = vLN02514;
                    }
                  } else {
                    v13709 = vLN02514;
                  }
                  if (v13706 && !v13705.secondary && !v13705.melee && !v13705.equipment) {
                    p17056.loadout[vLN02514] = v13704.id;
                    vUndefined11 = vLN02514;
                    break;
                  } else if (v13707 && v13705.secondary) {
                    p17056.loadout[vLN02514] = v13704.id;
                    vUndefined11 = vLN02514;
                    break;
                  } else if (v13708 && v13705.melee) {
                    p17056.loadout[vLN02514] = v13704.id;
                    vUndefined11 = vLN02514;
                    break;
                  }
                }
                if (vUndefined11 == null) {
                  p17056.loadoutIndex = vUndefined11;
                  if (v13708) {
                    p17056.loadout.push(v13704.id);
                  } else {
                    var v13712 = v13707 ? v13709 == -1 ? 0 : 1 : 0;
                    p17056.loadout.splice(v13712, 0, v13704.id);
                  }
                }
                var v13713 = p17056.loadout.indexOf(12) == -1;
                p17056.updateLoadout(game, p17056.loadoutIndex, true, p17056.loadout, undefined, undefined, undefined, v13713);
                game.broadcast("inat", p17056.sid, p17056.loadout, p17056.loadoutIndex, undefined, undefined, false, true, undefined, undefined, undefined, undefined, v13713);
              }
            }
          }
        },
        removePrimary: function () {
          if (game && p17043 && p17044) {
            var v13714;
            var vUndefined12 = undefined;
            for (var vLN02515 = 0; vLN02515 < p17056.loadout.length; vLN02515++) {
              v13714 = game.weaponConfig[p17056.loadout[vLN02515]];
              if (!v13714.secondary && !v13714.melee && !v13714.equipment) {
                vUndefined12 = vLN02515;
                break;
              }
            }
            var v13715 = p17056.loadout.indexOf(12) == -1;
            if (vUndefined12 != null) {
              p17056.loadout.splice(vUndefined12, 1);
              if (vUndefined12 < p17056.loadoutIndex) {
                p17056.loadoutIndex--;
              }
              p17056.updateLoadout(game, p17056.loadoutIndex, true, p17056.loadout, undefined, undefined, undefined, v13715);
              game.broadcast("inat", p17056.sid, p17056.loadout, p17056.loadoutIndex, undefined, undefined, false, true, undefined, undefined, undefined, undefined, v13715);
            }
          }
        },
        removeSecondary: function () {
          if (game && p17043 && p17044) {
            var v13716;
            var vUndefined13 = undefined;
            for (var vLN02516 = 0; vLN02516 < p17056.loadout.length; vLN02516++) {
              v13716 = game.weaponConfig[p17056.loadout[vLN02516]];
              if (v13716.secondary) {
                vUndefined13 = vLN02516;
                break;
              }
            }
            var v13717 = p17056.loadout.indexOf(12) == -1;
            if (vUndefined13 != null) {
              p17056.loadout.splice(vUndefined13, 1);
              if (vUndefined13 < p17056.loadoutIndex) {
                p17056.loadoutIndex--;
              }
              p17056.updateLoadout(game, p17056.loadoutIndex, true, p17056.loadout, undefined, undefined, undefined, v13717);
              game.broadcast("inat", p17056.sid, p17056.loadout, p17056.loadoutIndex, undefined, undefined, false, true, undefined, undefined, undefined, undefined, v13717);
            }
          }
        },
        removeMelee: function () {
          if (game && p17043 && p17044) {
            var v13718;
            var vUndefined14 = undefined;
            for (var vLN02517 = 0; vLN02517 < p17056.loadout.length; vLN02517++) {
              v13718 = game.weaponConfig[p17056.loadout[vLN02517]];
              if (v13718.melee) {
                vUndefined14 = vLN02517;
                break;
              }
            }
            var v13719 = true;
            if (vUndefined14 != null && p17056.loadout.length > 1) {
              p17056.loadout.splice(vUndefined14, 1);
              if (vUndefined14 < p17056.loadoutIndex) {
                p17056.loadoutIndex--;
              }
              p17056.updateLoadout(game, p17056.loadoutIndex, true, p17056.loadout, undefined, undefined, undefined, v13719);
              game.broadcast("inat", p17056.sid, p17056.loadout, p17056.loadoutIndex, undefined, undefined, false, true, undefined, undefined, undefined, undefined, v13719);
            }
          }
        },
        clearLoadout: function () {
          if (game && p17043 && p17044 && (p17056.loadout.length != 1 || p17056.loadout[0] != 12)) {
            p17056.updateLoadout(game, 0, true, [12]);
            game.broadcast("inat", p17056.sid, [12], 0, undefined, undefined, false);
          }
        },
        get score() {
          return p17056.score || 0;
        },
        set score(p17074) {
          if (game && p17043 && p17044 && UTILS.isNumber(p17074)) {
            game.players.score(p17056, parseInt(p17074) || 0, 0, true);
          }
        },
        get lives() {
          return p17056.lives || 0;
        },
        set lives(p17075) {
          if (game && p17043 && p17044) {
            p17075 = Math.max(0, parseInt(p17075 || 0) || 0);
            var v13720 = p17056.lives || 0;
            if (v13720 > 0 && p17075 == 0) {
              game.players.kill(p17056);
            } else {
              p17056.lives = p17075;
            }
          }
        },
        rotation: {
          get x() {
            return p17056.xDire;
          },
          set x(p17076) {
            p17056.xDire = parseFloat(p17076) || 0;
          },
          get y() {
            return p17056.yDire;
          },
          set y(p17077) {
            p17056.yDire = parseFloat(p17077) || 0;
          }
        },
        position: {
          get x() {
            return p17056.x;
          },
          set x(p17078) {
            p17056.x = parseFloat(p17078) || 0;
          },
          get y() {
            return p17056.y;
          },
          set y(p17079) {
            p17056.y = parseFloat(p17079) || 0;
          },
          get z() {
            return p17056.z;
          },
          set z(p17080) {
            p17056.z = parseFloat(p17080) || 0;
          }
        },
        velocity: {
          get x() {
            return p17056.velocity.x;
          },
          set x(p17081) {
            p17056.velocity.x = parseFloat(p17081) || 0;
          },
          get y() {
            return p17056.velocity.y;
          },
          set y(p17082) {
            p17056.velocity.y = parseFloat(p17082) || 0;
          },
          get z() {
            return p17056.velocity.z;
          },
          set z(p17083) {
            p17056.velocity.z = parseFloat(p17083) || 0;
          }
        },
        get health() {
          return p17056.health;
        },
        set health(p17084) {
          if (game) {
            p17084 = parseInt(p17084);
            p17084 = UTILS.isNumber(p17084) ? p17084 : p17056.health;
            if (game.players.setHealth(p17056, p17084)) {
              game.players.kill(p17056);
            }
          }
        },
        playAnim: function (p17085, p17086) {
          if (UTILS.isString(p17085)) {
            p17086 = UTILS.isNumber(p17086) ? p17086 : 1;
            if (p17056.meshRef && p17056.meshRef.playClip) {
              p17056.meshRef.playClip(p17085, p17086);
            }
          }
        },
        stopAnim: function () {
          if (p17056.meshRef && p17056.meshRef.stopAllClips) {
            p17056.meshRef.stopAllClips();
          }
        },
        registerSyncValues: function (p17087) {
          if (!config.serverScripting) {
            return false;
          }
          if (!p17043 || !p17044) {
            return false;
          }
          if (game) {
            if (UTILS.isString(p17087)) {
              p17087 = [p17087];
            }
            if (!Array.isArray(p17087)) {
              return false;
            }
            for (let vLN02518 = 0; vLN02518 < p17087.length; vLN02518++) {
              if (p17056.custSync.length >= 20) {
                return false;
              }
              var v13721 = p17087[vLN02518] + "";
              if (!(v13721.length > 20)) {
                p17056.custSync.push(v13721);
              }
            }
          }
        },
        deregisterSyncValues: function (p17088) {
          if (!config.serverScripting) {
            return false;
          }
          if (!p17043 || !p17044) {
            return false;
          }
          if (game) {
            if (UTILS.isString(p17088)) {
              p17088 = [p17088];
            }
            if (!Array.isArray(p17088)) {
              return false;
            }
            for (let vLN02519 = 0; vLN02519 < p17088.length; vLN02519++) {
              var v13722 = p17088[vLN02519] + "";
              if (!(v13722.length > 20)) {
                var v13723 = p17056.custSync.indexOf(v13722);
                if (v13723 >= 0) {
                  p17056.custSync.splice(v13723, 1);
                }
              }
            }
          }
        },
        respawn: function () {
          return !!config.serverScripting && !!p17043 && !!p17044 && void (!game || (p17056.lives <= 0 && (p17056.lives = 1), !p17056.active && p17056.send("frs", true)));
        }
      };
    },
    AI: function (p17089) {
      return p17089._protected ||= {
        get sid() {
          return p17089.sid;
        },
        get displayName() {
          return p17089.name;
        },
        position: {
          get x() {
            return p17089.x;
          },
          set x(p17090) {
            p17089.x = parseFloat(p17090) || 0;
          },
          get y() {
            return p17089.y;
          },
          set y(p17091) {
            p17089.y = parseFloat(p17091) || 0;
          },
          get z() {
            return p17089.z;
          },
          set z(p17092) {
            p17089.z = parseFloat(p17092) || 0;
          }
        },
        rotation: {
          get x() {
            return player.xD;
          },
          set x(p17093) {
            player.xD = parseFloat(p17093) || 0;
          },
          get y() {
            return player.yD;
          },
          set y(p17094) {
            player.yD = parseFloat(p17094) || 0;
          }
        },
        get pathIndex() {
          return p17089.pathIndex;
        },
        set behaviour(p17095) {
          p17089.pathIndex = parseFloat(p17095) || 0;
        },
        get behaviour() {
          return p17089.behavior;
        },
        set behaviour(p17096) {
          p17089.behavior = parseFloat(p17096) || 0;
        },
        get health() {
          return p17089.health;
        },
        set health(p17097) {
          if (game) {
            p17097 = parseInt(p17097);
            p17097 = UTILS.isNumber(p17097) ? p17097 : p17089.health;
            p17089.changeHealth(p17097, null, false, true);
          }
        },
        playAnim: function (p17098, p17099) {
          if (p17043 && UTILS.isString(p17098)) {
            p17099 = UTILS.isNumber(p17099) ? p17099 : 1;
            game.AI.playAnim(p17089, p17098, p17099, true);
          }
        }
      };
    },
    sound: function (p17100) {
      return p17100._protected ||= {
        get volume() {
          return p17100.vol;
        },
        set volume(p17101) {
          p17100.vol = parseFloat(p17101) || 0;
          p17100.sound.volume(p17100.vol * p17048.volumes[6], p17100.id);
        },
        get rate() {
          return p17100.rate;
        },
        set rate(p17102) {
          p17100.rate = parseFloat(p17102) || 0;
          p17100.sound.rate((p17100.rate || 1) * p17048.rate, p17100.id);
        },
        fade: function (p17103, p17104, p17105) {
          p17103 = UTILS.isNumber(p17103) ? p17103 : 0;
          p17104 = UTILS.isNumber(p17104) ? p17104 : 1;
          p17105 = UTILS.isNumber(p17105) ? p17105 : 0;
          p17100.sound.fade(p17103, p17104, p17105, p17100.id);
        },
        mute: function () {
          p17100.sound.mute(true, p17100.id);
        },
        unmute: function () {
          p17100.sound.mute(false, p17100.id);
        },
        play: function () {
          p17100.sound.isPlaying = true;
          p17100.sound.play(p17100.id);
        },
        stop: function () {
          p17100.sound.isPlaying = false;
          p17100.sound.stop(p17100.id);
        },
        pause: function () {
          p17100.sound.pause(p17100.id);
        }
      };
    },
    obj3D: function (p17106, p17107) {
      p17106.data = p17107 || {};
      return p17106._protected ||= {
        get id() {
          return p17106.id;
        },
        get visible() {
          return !!p17106.visible;
        },
        set visible(p17108) {
          p17106.visible = !!p17108;
        },
        get emissive() {
          return "";
        },
        set emissive(p17109) {
          if (UTILS.isHexColor(p17109) && p17106 && p17106.material) {
            p17106.data.emissive = p17109;
            p17106.material = RENDER.getMat(RENDER.noTex ? "default" : p17106.data.src, p17106.data);
            p17106.material.needsUpdate = true;
          }
        },
        get opacity() {
          if (p17106 && p17106.material) {
            return p17106.material.opacity || 0;
          } else {
            return 1;
          }
        },
        set opacity(p17110) {
          p17110 = UTILS.isNumber(p17110) ? p17110 : 1;
          if (!!p17106 && !!p17106.material) {
            var v13724 = p17106.data && (p17106.data.fileExt == "fbx" || p17106.data.fileExt == "gltf" || p17106.data.fileExt == "glb");
            if (v13724) {
              p17106.traverse(p17111 => {
                if (p17111.isMesh) {
                  RENDER.traverseMats(p17111, function (p17112) {
                    p17112.opacity = p17110;
                    p17112.transparent = p17110 != 1;
                    p17112.needsUpdate = true;
                  });
                }
              });
            } else {
              p17106.material.opacity = p17110;
              p17106.material.transparent = p17110 != 1;
              p17106.material.needsUpdate = true;
            }
          }
        },
        set texture(p17113) {
          if (!p17106.data.isMdl) {
            if (UTILS.isNumber(p17113)) {
              p17106.data.src = p17113 + "/texture";
              p17106.data.asset = p17113;
            }
            p17106.material = RENDER.getMat(RENDER.noTex ? "default" : p17106.data.src, p17106.data);
            p17106.material.map.needsUpdate = true;
          }
        },
        get texture() {
          return p17106.data.asset || 0;
        },
        set animSpeed(p17114) {
          if (p17106.data.isMdl) {
            p17106.data.animS = UTILS.isNumber(p17114) ? parseFloat(p17114) : 0;
            if (p17106.mixer) {
              p17106.mixer.timeScale = p17106.data.animS || 1;
            }
          }
        },
        get animSpeed() {
          return p17106.data.animS || 1;
        },
        move: function (p17115, p17116, p17117) {
          if (RENDER && p17106 && p17106.position) {
            p17106.position.x = parseFloat(p17115) || 0;
            p17106.position.y = parseFloat(p17116) || 0;
            p17106.position.z = parseFloat(p17117) || 0;
          }
        },
        position: {
          get x() {
            return p17106.position.x;
          },
          set x(p17118) {
            p17106.position.x = parseFloat(p17118) || 0;
          },
          get y() {
            return p17106.position.y;
          },
          set y(p17119) {
            p17106.position.y = parseFloat(p17119) || 0;
          },
          get z() {
            return p17106.position.z;
          },
          set z(p17120) {
            p17106.position.z = parseFloat(p17120) || 0;
          }
        },
        rotate: function (p17121, p17122, p17123) {
          if (RENDER && p17106 && p17106.rotation) {
            p17106.rotation.x = parseFloat(p17121) || 0;
            p17106.rotation.y = parseFloat(p17122) || 0;
            p17106.rotation.z = parseFloat(p17123) || 0;
          }
        },
        rotateLocal: function (p17124, p17125, p17126) {
          if (!RENDER) {
            return;
          }
          if (!p17106 || !p17106.rotation) {
            return;
          }
          p17124 = parseFloat(p17124) || 0;
          p17125 = parseFloat(p17125) || 0;
          p17126 = parseFloat(p17126) || 0;
          const v13725 = new RENDER.THREE.Box3().setFromObject(p17106);
          const v13726 = v13725.getCenter(new RENDER.THREE.Vector3());
          var v13727 = new RENDER.THREE.Vector3(1, 0, 0);
          if (p17124) {
            p17106.position.sub(v13726);
            p17106.position.applyAxisAngle(v13727, p17124);
            p17106.position.add(v13726);
            p17106.rotateOnWorldAxis(v13727, p17124);
          }
          if (p17125) {
            v13727.set(0, 1, 0);
            p17106.position.sub(v13726);
            p17106.position.applyAxisAngle(v13727, p17125);
            p17106.position.add(v13726);
            p17106.rotateOnWorldAxis(v13727, p17125);
          }
          if (p17126) {
            v13727.set(0, 0, 1);
            p17106.position.sub(v13726);
            p17106.position.applyAxisAngle(v13727, p17126);
            p17106.position.add(v13726);
            p17106.rotateOnWorldAxis(v13727, p17126);
          }
        },
        rotation: {
          get x() {
            return p17106.rotation.x;
          },
          set x(p17127) {
            p17106.rotation.x = parseFloat(p17127) || 0;
          },
          get y() {
            return p17106.rotation.y;
          },
          set y(p17128) {
            p17106.rotation.y = parseFloat(p17128) || 0;
          },
          get z() {
            return p17106.rotation.z;
          },
          set z(p17129) {
            p17106.rotation.z = parseFloat(p17129) || 0;
          }
        },
        lookAt: function (p17130, p17131, p17132) {
          if (RENDER) {
            p17130 = parseFloat(p17130) || 0;
            p17131 = parseFloat(p17131) || 0;
            p17132 = parseFloat(p17132) || 0;
            if (p17106.target) {
              p17106.target.position.set(p17130, p17131, p17132);
            } else {
              p17106.lookAt(p17130, p17131, p17132);
            }
          }
        },
        scale: {
          get x() {
            return p17106.scale.x;
          },
          set x(p17133) {
            p17106.scale.x = parseFloat(p17133) || 0;
          },
          get y() {
            return p17106.scale.y;
          },
          set y(p17134) {
            p17106.scale.y = parseFloat(p17134) || 0;
          },
          get z() {
            return p17106.scale.z;
          },
          set z(p17135) {
            p17106.scale.z = parseFloat(p17135) || 0;
          }
        },
        playAnim: function (p17136, p17137) {
          if (RENDER && UTILS.isString(p17136)) {
            p17137 = UTILS.isNumber(p17137) ? p17137 : 1;
            if (p17106 && p17106.playClip) {
              p17106.playClip(p17136, p17137);
            }
          }
        },
        stopAnim: function () {
          if (RENDER) {
            if (p17106 && p17106.stopAllClips) {
              p17106.stopAllClips();
            }
          }
        },
        getBone: function (p17138) {
          if (RENDER && UTILS.isString(p17138)) {
            var v13728 = RENDER.traverseBones(p17106, p17138);
            if (v13728) {
              return vO444.aBone(v13728);
            } else {
              return undefined;
            }
          }
        },
        updateMorph: function (p17139, p17140) {
          if (RENDER && UTILS.isString(p17139)) {
            p17140 = UTILS.isNumber(p17140) ? p17140 : 0;
            if (p17106 && p17106.updateMorphKey) {
              p17106.updateMorphKey(p17139, p17140);
            }
          }
        },
        delete: function () {
          if (RENDER && p17106) {
            RENDER.scene.remove(p17106);
          }
        },
        attachTo: function (p17141, p17142, p17143, p17144, p17145) {
          if (!RENDER || !p17106 || !game) {
            return;
          }
          var v13729 = RENDER.genObj3D(p17142 || 0, p17143 || 0, p17144 || 0);
          v13729.name = "attachTo";
          const v13730 = p17141[v13689("sid")];
          const v13731 = p17141[v13689("id")];
          if (v13730 != null) {
            for (var vLN02520 = 0; vLN02520 < game.players.list.length; vLN02520++) {
              if (game.players.list[vLN02520].sid == v13730) {
                if (p17145) {
                  v13729.attach(p17106);
                } else {
                  v13729.add(p17106);
                }
                if (p17145) {
                  game.players.list[vLN02520].objInstances.attach(v13729);
                } else {
                  game.players.list[vLN02520].objInstances.add(v13729);
                }
                break;
              }
            }
          } else {
            var v13732 = RENDER.scene.getObjectById(v13731, true);
            if (v13732) {
              if (p17145) {
                v13729.attach(p17106);
              } else {
                v13729.add(p17106);
              }
              if (p17145) {
                v13732.attach(v13729);
              } else {
                v13732.add(v13729);
              }
            }
          }
        },
        detach: function (p17146) {
          if (RENDER && p17106 && game) {
            if (p17106.parent.name == "attachTo") {
              p17106.parent.parent.remove(p17106.parent);
              p17106.parent = null;
              if (p17146) {
                RENDER.scene.attach(p17106);
              } else {
                RENDER.scene.add(p17106);
              }
            }
          }
        }
      };
    },
    aBone: function (p17147) {
      return p17147._protected ||= {
        get id() {
          return p17147.id;
        },
        move: function (p17148, p17149, p17150) {
          if (RENDER && p17147 && p17147.position) {
            p17147.position.x = parseFloat(p17148) || 0;
            p17147.position.y = parseFloat(p17149) || 0;
            p17147.position.z = parseFloat(p17150) || 0;
          }
        },
        position: {
          get x() {
            return p17147.position.x;
          },
          set x(p17151) {
            p17147.position.x = parseFloat(p17151) || 0;
          },
          get y() {
            return p17147.position.y;
          },
          set y(p17152) {
            p17147.position.y = parseFloat(p17152) || 0;
          },
          get z() {
            return p17147.position.z;
          },
          set z(p17153) {
            p17147.position.z = parseFloat(p17153) || 0;
          }
        },
        rotation: {
          get x() {
            return p17147.rotation.x;
          },
          set x(p17154) {
            p17147.rotation.x = parseFloat(p17154) || 0;
          },
          get y() {
            return p17147.rotation.y;
          },
          set y(p17155) {
            p17147.rotation.y = parseFloat(p17155) || 0;
          },
          get z() {
            return p17147.rotation.z;
          },
          set z(p17156) {
            p17147.rotation.z = parseFloat(p17156) || 0;
          }
        },
        scale: {
          get x() {
            return p17147.scale.x;
          },
          set x(p17157) {
            p17147.scale.x = parseFloat(p17157) || 0;
          },
          get y() {
            return p17147.scale.y;
          },
          set y(p17158) {
            p17147.scale.y = parseFloat(p17158) || 0;
          },
          get z() {
            return p17147.scale.z;
          },
          set z(p17159) {
            p17147.scale.z = parseFloat(p17159) || 0;
          }
        }
      };
    },
    obj3DServ: function (p17160) {
      return p17160._protected ||= {
        get sid() {
          return p17160.sid;
        },
        position: {
          get x() {
            return p17160.x;
          },
          get y() {
            return p17160.y;
          },
          get z() {
            return p17160.z;
          }
        },
        scale: {
          get x() {
            return p17160.width;
          },
          get y() {
            return p17160.height;
          },
          get z() {
            return p17160.length;
          }
        }
      };
    },
    trigger: function (p17161) {
      return p17161._protected ||= {
        position: {
          get x() {
            return p17161.x;
          },
          get y() {
            return p17161.y;
          },
          get z() {
            return p17161.z;
          }
        },
        scale: {
          get x() {
            return p17161.width;
          },
          get y() {
            return p17161.height;
          },
          get z() {
            return p17161.length;
          }
        }
      };
    },
    node: function (p17162) {
      return p17162._protected ||= {
        get id() {
          return p17162.id;
        },
        get x() {
          return p17162.x;
        },
        get y() {
          return p17162.y;
        },
        get z() {
          return p17162.z;
        }
      };
    },
    NFT: function (p17163) {
      return p17163._protected ||= {
        get name() {
          return p17163.name || "";
        },
        get id() {
          return p17163.id;
        },
        get tokenID() {
          return p17163.token_id;
        },
        get contractAddress() {
          return p17163.asset_contract.address;
        },
        get collection() {
          return p17163.collection.name;
        },
        openListing: function () {}
      };
    }
  };
  const vO445 = {
    AI: function (p17164, p17165) {
      p17164.canHit = !!p17165[v13689("canMelee")];
      p17164.canShoot = !!p17165[v13689("canShoot")];
      if (UTILS.isNumber(p17165[v13689("modelScale")]) && p17165[v13689("modelScale")]) {
        p17164.mSize = parseFloat(p17165[v13689("modelScale")]);
        p17164.mSize = UTILS.limitMM(p17164.mSize, 0.01, 100).round(2);
      }
      p17164.health = UTILS.isNumber(p17165[v13689("health")]) ? parseInt(p17165[v13689("health")]) : 0;
      p17164.speed = UTILS.isNumber(p17165[v13689("speed")]) ? parseFloat(p17165[v13689("speed")]) : 0;
      p17164.speed = UTILS.limitMM(p17164.speed, 0, 10);
      p17164.turnSpd = UTILS.isNumber(p17165[v13689("turnSpeed")]) ? parseFloat(p17165[v13689("turnSpeed")]) : 0;
      p17164.turnSpd = UTILS.limitMM(p17164.turnSpd, 0, 10);
      p17164.grv = UTILS.isNumber(p17165[v13689("gravity")]) ? parseFloat(p17165[v13689("gravity")]) : 0;
      p17164.grv = UTILS.limitMM(p17164.grv, 0, 1);
      p17164.roamTime = UTILS.isNumber(p17165[v13689("roamTime")]) ? parseInt(p17165[v13689("roamTime")]) : 0;
      p17164.roamTime = UTILS.limitMM(p17164.roamTime, 1000, 10000);
      p17164.roamRad = UTILS.isNumber(p17165[v13689("roamRadius")]) ? parseInt(p17165[v13689("roamRadius")]) : 0;
      p17164.roamRad = UTILS.limitMM(p17164.roamRad, 0, 500);
      p17164.aiChasd = UTILS.isNumber(p17165[v13689("chaseDis")]) ? parseInt(p17165[v13689("chaseDis")]) : 0;
      p17164.aiChasd = UTILS.limitMM(p17164.aiChasd, 0, 2000);
      p17164.hbh = UTILS.isNumber(p17165[v13689("hitBoxH")]) ? parseFloat(p17165[v13689("hitBoxH")]) || 1 : 1;
      p17164.hbh = UTILS.limitMM(p17164.hbh, 0.1, 10);
      p17164.hbw = UTILS.isNumber(p17165[v13689("hitBoxW")]) ? parseFloat(p17165[v13689("hitBoxW")]) || 1 : 1;
      p17164.hbw = UTILS.limitMM(p17164.hbw, 0.1, 10);
      p17164.frate = UTILS.isNumber(p17165[v13689("fireRate")]) ? parseInt(p17165[v13689("fireRate")]) : 0;
      p17164.frate = UTILS.limitMM(p17164.frate, 200, 10000);
      p17164.aicur = UTILS.isNumber(p17165[v13689("shotSpread")]) ? parseInt(p17165[v13689("shotSpread")]) : 0;
      p17164.aicur = UTILS.limitMM(p17164.aicur, 0, 10);
      p17164.shoBrk = UTILS.isNumber(p17165[v13689("shotBreak")]) ? parseInt(p17165[v13689("shotBreak")]) : 0;
      p17164.shoBrk = UTILS.limitMM(p17164.shoBrk, 0, 5000);
      p17164.shoArY = UTILS.isNumber(p17165[v13689("shotArchY")]) ? parseInt(p17165[v13689("shotArchY")]) : 0;
      p17164.shoArY = UTILS.limitMM(p17164.shoArY, -90, 90);
      p17164.shoOffH = !!p17165[v13689("shotOffH")];
      p17164.shoDel = UTILS.isNumber(p17165[v13689("shotDelay")]) ? parseInt(p17165[v13689("shotDelay")]) : 0;
      p17164.shoDel = UTILS.limitMM(p17164.shoDel, 0, 5000);
      p17164.melDel = UTILS.isNumber(p17165[v13689("meleeDelay")]) ? parseInt(p17165[v13689("meleeDelay")]) : 0;
      p17164.melDel = UTILS.limitMM(p17164.melDel, 0, 5000);
      p17164.melShake = UTILS.isNumber(p17165[v13689("meleeShake")]) ? parseInt(p17165[v13689("meleeShake")]) : 0;
      p17164.melShake = UTILS.limitMM(p17164.melShake, 0, 1);
      p17164.shoShake = UTILS.isNumber(p17165[v13689("shotShake")]) ? parseInt(p17165[v13689("shotShake")]) : 0;
      p17164.shoShake = UTILS.limitMM(p17164.shoShake, 0, 1);
      p17164.shotEff = UTILS.isNumber(p17165[v13689("shotEffect")]) ? parseInt(p17165[v13689("shotEffect")]) : undefined;
      if (p17164.shotEff != null) {
        p17164.shotEff = UTILS.limitMM(p17164.shotEff, 0, 9);
      }
      p17164.hitEff = UTILS.isNumber(p17165[v13689("hitEffect")]) ? parseInt(p17165[v13689("hitEffect")]) : undefined;
      if (p17164.hitEff != null) {
        p17164.hitEff = UTILS.limitMM(p17164.hitEff, 0, 9);
      }
      p17164.critDmg = UTILS.isNumber(p17165[v13689("critDamage")]) ? parseInt(p17165[v13689("critDamage")]) : 0;
      p17164.critDmg = UTILS.limitMM(p17164.critDmg, 0, 5);
      p17164.hrate = UTILS.isNumber(p17165[v13689("meleeRate")]) ? parseInt(p17165[v13689("meleeRate")]) : 0;
      p17164.hrate = UTILS.limitMM(p17164.hrate, 200, 10000);
      p17164.melrng = UTILS.isNumber(p17165[v13689("meleeRange")]) ? parseInt(p17165[v13689("meleeRange")]) : 0;
      p17164.melrng = UTILS.limitMM(p17164.melrng, 10, 100);
      p17164.meldmg = UTILS.isNumber(p17165[v13689("meleeDmg")]) ? parseInt(p17165[v13689("meleeDmg")]) : 0;
      p17164.meldmg = UTILS.limitMM(p17164.meldmg, 1, 200);
      p17164.visDis = UTILS.isNumber(p17165[v13689("visionDis")]) ? parseInt(p17165[v13689("visionDis")]) : 0;
      p17164.visDis = UTILS.limitMM(p17164.visDis, 1, 1000);
      p17164.score = UTILS.isNumber(p17165[v13689("score")]) ? parseInt(p17165[v13689("score")]) : 0;
      p17164.score = UTILS.limitMM(p17164.score, 0, 10000);
      p17164.behav = UTILS.isNumber(p17165[v13689("behaviorType")]) ? parseInt(p17165[v13689("behaviorType")]) : 0;
      p17164.behav = UTILS.limitMM(p17164.behav, 0, 20);
      p17164.startAnim = p17165[v13689("animStart")];
      if (p17164.startAnim && UTILS.isString(p17164.startAnim) && p17164.startAnim != "") {
        if (p17164.startAnim.length > 32) {
          p17164.startAnim = "";
        }
        if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p17164.startAnim)) {
          p17164.startAnim = "";
        }
      } else {
        p17164.startAnim = "";
      }
      p17164.animS = UTILS.isNumber(p17165[v13689("animSpeed")]) ? parseFloat(p17165[v13689("animSpeed")]) : 0;
      p17164.mYOff = UTILS.isNumber(p17165[v13689("modelOffsetY")]) ? parseFloat(p17165[v13689("modelOffsetY")]) : 0;
      p17164.mYOff = UTILS.limitMM(p17164.mYOff, -100, 100);
      p17164.mROff = UTILS.isNumber(p17165[v13689("modelRotation")]) ? parseFloat(p17165[v13689("modelRotation")]) : 0;
      p17164.mROff = UTILS.limitMM(p17164.mROff, 0, 360);
      return p17164;
    },
    obj: function (p17166, p17167, p17168) {
      if (p17168 != 2) {
        if (p17167[v13689("textureStretching")]) {
          p17166.scale = 0;
        }
        p17166.scaleM = parseFloat(p17167[v13689("textureScale")]) || 0;
        p17166.movT = UTILS.isNumber(p17167[v13689("textureMoveSpeed")]) ? p17167[v13689("textureMoveSpeed")] / 10000 : undefined;
        p17166.movD = p17167[v13689("textureMoveAxis")] == "x" ? 0 : p17167[v13689("textureMoveAxis")] == "y" ? 1 : UTILS.limitMM(parseInt(p17167[v13689("textureMoveAxis")]) || 0, 0, 1);
        p17166.texOffX = UTILS.isNumber(p17167[v13689("textureOffsetX")]) ? parseFloat(p17167[v13689("textureOffsetX")]) : 0;
        p17166.texOffX = UTILS.limitMM(p17166.texOffX || 0, 0, 1).round(2);
        p17166.texOffY = UTILS.isNumber(p17167[v13689("textureOffsetY")]) ? parseFloat(p17167[v13689("textureOffsetY")]) : 0;
        p17166.texOffY = UTILS.limitMM(p17166.texOffY || 0, 0, 1).round(2);
        p17166.texRot = UTILS.isNumber(p17167[v13689("textureRotation")]) ? parseFloat(p17167[v13689("textureRotation")]) : 0;
        p17166.texRot = UTILS.limitMM(p17166.texRot, 0, 360);
        p17166.frames = UTILS.limitMM(parseInt(p17167[v13689("textureFrameCount")]) || 0, 0, 100);
        p17166.frameT = UTILS.limitMM(parseFloat(p17167[v13689("textureFrameDuration")]) || 0, 0, 10).round(1) * 100;
        p17166.emissive = UTILS.isHexColor(p17167[v13689("emissive")]) ? p17167[v13689("emissive")] : null;
        p17166.texEncode = UTILS.limitMM(parseInt(p17167[v13689("textureEncoding")]) || 0, 0, config.encodingTypes.length - 1);
        var v13733 = p17167[v13689("aid")];
        var vParseInt53 = parseInt(v13733);
        if (v13733 != vParseInt53 && v13733 != null) {
          var v13734 = (v13733 + "").includes("v") ? vParseInt53 : undefined;
          p17166.src = (vParseInt53 || 0) + (v13734 ? "/video" : "/texture");
          p17166.video = v13734;
          p17166.asset = vParseInt53;
        } else if (UTILS.isNumber(vParseInt53)) {
          p17166.src = vParseInt53 + "/texture";
          p17166.asset = vParseInt53;
        }
      } else {
        p17166.tFilter = p17167[v13689("textureSmoothing")] ? RENDER.THREE.LinearFilter : RENDER.THREE.NearestFilter;
        p17166.spin = UTILS.isNumber(p17167[v13689("spinSpeed")]) ? UTILS.limitMM(p17167[v13689("spinSpeed")], -20, 20) : 0;
        if (p17166.spin != 0) {
          p17166.rAnim = (p17166.spin || 0) * config.diskSpin;
          p17166.rAnimA = p17166.spinAxis ? "x" : "y";
        }
        p17166.spinAxis = p17167[v13689("spinAxis")] != "x" && UTILS.isNumber(p17167[v13689("spinAxis")]) && p17167[v13689("spinAxis")] ? 1 : 0;
        if (UTILS.isNumber(p17167[v13689("alphaTest")]) && p17167[v13689("alphaTest")]) {
          p17166.alphaTest = UTILS.limitMM(parseFloat(p17167[v13689("alphaTest")] || 0), 0, 1).round(2);
        }
        p17166.forceRender = !!p17167[v13689("alwaysRender")];
        p17166.animS = UTILS.isNumber(p17167[v13689("animSpeed")]) ? parseFloat(p17167[v13689("animSpeed")]) : 0;
        p17166.startAnim = p17167[v13689("animStart")];
        if (p17166.startAnim && UTILS.isString(p17166.startAnim) && p17166.startAnim != "") {
          if (p17166.startAnim.length > 32) {
            p17166.startAnim = "";
          }
          if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p17166.startAnim)) {
            p17166.startAnim = "";
          }
        } else {
          p17166.startAnim = "";
        }
        p17166.shadows = p17167[v13689("castShadows")] || !p17167[v13689("receiveShadows")] && p17167[v13689("opacity")] == 1;
        p17166.shadowsR = !!p17167[v13689("receiveShadows")];
      }
      if (p17168 == 1 && p17167[v13689("mimicSprite")]) {
        p17166.mimicSprite = true;
        p17166.color = "#FFFFFF";
        p17166.mat = RENDER.THREE.SpriteMaterial;
      }
      p17166.opacity = UTILS.isNumber(p17167[v13689("opacity")]) ? p17167[v13689("opacity")] : 1;
      p17166.transparent = p17167[v13689("forceTransparency")] || p17166.opacity != 1;
      if (UTILS.isNumber(p17167[v13689("side")])) {
        p17166.side = UTILS.limitMM(p17167[v13689("side")], 0, 2);
      }
      if (p17167[v13689("doubleSided")]) {
        p17166.side = 2;
      }
      if (p17167[v13689("backSided")]) {
        p17166.side = 1;
      }
      if (p17167[v13689("frontSided")]) {
        p17166.side = 0;
      }
      if (p17168 == 3) {
        p17166.thetaL = UTILS.isNumber(p17167[v13689("thetaLength")]) ? parseFloat(p17167[v13689("thetaLength")]) : 360;
        p17166.thetaL = UTILS.limitMM(parseFloat(p17166.thetaL) || 0.1, 0.1, 360).round(2);
        p17166.sides = UTILS.isNumber(p17167[v13689("sides")]) ? parseInt(p17167[v13689("sides")]) : 12;
        p17166.sides = UTILS.limitMM(parseInt(p17166.sides) || 12, 3, 64);
      }
      return p17166;
    },
    sign: function (p17169, p17170, p17171, p17172) {
      p17169.fontSize = UTILS.isNumber(p17170[v13689("fontSize")]) ? parseInt(p17170[v13689("fontSize")]) : 10;
      p17169.fontSize = UTILS.limitMM(p17169.fontSize || 10, 10, 120);
      p17169.fcolr = UTILS.isHexColor(p17170[v13689("fontColor")]) ? p17170[v13689("fontColor")] : "#000";
      p17169.bcolr = UTILS.isHexColor(p17170[v13689("backgroundColor")]) ? p17170[v13689("backgroundColor")] : "#fff";
      p17169.noBVis = !!p17170[v13689("backgroundInvisible")];
      p17169.tAlign = UTILS.isString(p17170[v13689("textAlign")]) ? p17170[v13689("textAlign")] == "left" ? 0 : p17170[v13689("textAlign")] == "center" ? 1 : p17170[v13689("textAlign")] == "right" ? 2 : 0 : UTILS.isNumber(p17170[v13689("textAlign")]) ? UTILS.limitMM(parseInt(p17170[v13689("textAlign")]) || 0, 0, 2) : 0;
      p17169.ocolr = UTILS.isHexColor(p17170[v13689("outlineColor")]) ? p17170[v13689("outlineColor")] : "#626262";
      p17169.othick = UTILS.isNumber(p17170[v13689("outlineThickness")]) ? parseInt(p17170[v13689("outlineThickness")]) : 0;
      p17169.othick = UTILS.limitMM(p17169.othick || 1, 1, 50);
      p17169.noSCF = !!p17170[v13689("noScaleFont")];
      p17169.canvas = UTILS.createCanvasText(p17171 * 2, p17172 * 2, p17169.text || "Hello World", p17169.fontSize || 10, p17169.fcolr, p17169.bcolr, p17169.noBVis, p17169.tAlign || 0, p17169.ocolr, p17169.othick, !!p17169.noSCF);
      if (p17170[v13689("mimicSprite")]) {
        p17169.mimicSprite = true;
        p17169.color = "#FFFFFF";
        p17169.mat = RENDER.THREE.SpriteMaterial;
      }
      return p17169;
    }
  };
  return {
    context: {
      log: function (...iIïîïïi) {
        p17041.log(iIïîïïi.map(p17173 => p17040.sanitize(p17173)));
      },
      changeGame: function (p17174) {
        if (!p17043 && !f2123("g_change", 3)) {
          p17174 = UTILS.escapeStr(p17174 + "");
          if (p17174 && p17174.length) {
            window.playMap(p17174);
          }
        }
      },
      setTitle: function (p17175) {
        if (!p17043) {
          if (UTILS.isString(p17175)) {
            p17175 = p17175.replace(/[^\w\-\ ]+/gmi, "");
            if (p17175.length) {
              document.title = p17175;
            }
          }
        }
      },
      DEFAULT: {
        disablePlayerBehaviour: function () {
          if (game) {
            game.noDefaultBehav = true;
          }
        },
        disable3D: function () {
          if (RENDER) {
            RENDER.disable();
          }
        },
        disablePrediction: function () {
          if (game) {
            game.noPred = true;
          }
        },
        disableServerSync: function () {
          if (game) {
            game.noSync = true;
          }
        }
      },
      NETWORK: {
        broadcast: function (p17176, p17177) {
          if (!config.serverScripting) {
            return false;
          }
          if (!p17043 || !p17044) {
            return false;
          }
          if (f2123("c_broad", 10)) {
            return false;
          }
          try {
            var v13735 = Array.isArray(p17177) || typeof p17177 == "object" ? JSON.stringify(p17177).length : (p17177 + "").length;
            return !(v13735 > 2000) && (game.broadcast("sd", p17176, p17177), true);
          } catch (e173) {
            return false;
          }
        },
        send: function (p17178, p17179, p17180) {
          if (!config.serverScripting) {
            return false;
          }
          if (!p17044) {
            return false;
          }
          p17180 = (p17180 || "") + "";
          if (p17043 && f2123("n_send" + p17180, 20)) {
            return false;
          }
          try {
            var v13736 = Array.isArray(p17179) || typeof p17179 == "object" ? JSON.stringify(p17179).length : (p17179 + "").length;
            if (v13736 > 2000) {
              return false;
            }
            if (p17043) {
              return !!p17180 && (p17044.send(p17180 + "", "sd", p17178, p17179), true);
            }
            p17044.send("sd", p17178, p17179);
          } catch (e174) {
            return false;
          }
        }
      },
      URLS: {
        openDiscord: function () {},
        openTwitter: function () {},
        openYoutube: function () {},
        openOpensea: function () {}
      },
      NFT: {
        hasWallet: function (p17181) {
          var v13737 = game.players.list.find(p17182 => p17182.id == p17181);
          return !!v13737 && !!v13737.account && !!v13737.account.metamask;
        },
        ownedAssets: function (p17183, p17184, p17185) {
          if (p17047 && p17044) {
            var v13738 = game.players.list.find(p17186 => p17186.id == p17183);
            if (v13738 && v13738.account && v13738.account.metamask) {
              if (p17185 && typeof p17185 == "function") {
                p17184 = UTILS.isString(p17184) ? p17184 + "" : undefined;
                p17047.getAssetsOwned(v13738.account.metamask, p17184).then(p17187 => {
                  if (p17187 && p17187.assets) {
                    p17185(true, p17187.assets.map(vO444.NFT));
                  } else {
                    f2125("No NFTs owned in this collection");
                    p17185(false, []);
                  }
                });
                return;
              } else {
                f2125("Invalid callback");
                return;
              }
            } else {
              f2125("Missing wallet or player");
              return;
            }
          }
        }
      },
      CHAT: {
        send: function (p17188, p17189, p17190) {
          if (p17043 && p17044) {
            if (!f2123("c_send", 3)) {
              p17190 = UTILS.isHexColor(p17190) ? p17190 : "#fc03ec";
              if (p17189 && UTILS.isString(p17189) && p17189.length <= config.chatMaxLength && p17189.replace(/\s/g, "").length > 0) {
                p17189 = p17189.replace(/[^\w:\(\)\/? -]+/gmi, "").replace(/\//gmi, "");
                if (p17188) {
                  p17044.send(p17188 + "", "ch", -1, null, p17189, 2, p17190);
                } else {
                  game.broadcast("ch", -1, null, p17189, 2, p17190);
                }
              }
            }
          }
        },
        broadcast: function (p17191, p17192) {
          if (p17043 && p17044) {
            if (!f2123("c_broadcast", 3)) {
              p17192 = UTILS.isHexColor(p17192) ? p17192 : "#fc03ec";
              if (p17191 && UTILS.isString(p17191) && p17191.length <= config.chatMaxLength && p17191.replace(/\s/g, "").length > 0) {
                p17191 = p17191.replace(/[^\w:\(\)\/? -]+/gmi, "").replace(/\//gmi, "");
                game.broadcast("ch", -1, null, p17191, 2, p17192);
              }
            }
          }
        }
      },
      UTILS: {
        math: {
          E: Math.E,
          PI: Math.PI,
          PI2: Math.PI * 2,
          sin: p17193 => Math.sin(p17193) || 0,
          sinh: p17194 => Math.sinh(p17194) || 0,
          cos: p17195 => Math.cos(p17195) || 0,
          cosh: p17196 => Math.cosh(p17196) || 0,
          tan: p17197 => Math.tan(p17197) || 0,
          tanh: p17198 => Math.tanh(p17198) || 0,
          asin: p17199 => Math.asin(p17199) || 0,
          asinh: p17200 => Math.asinh(p17200) || 0,
          acos: p17201 => Math.acos(p17201) || 0,
          acosh: p17202 => Math.acosh(p17202) || 0,
          atan: p17203 => Math.atan(p17203) || 0,
          atan2: (p17204, p17205) => Math.atan2(p17204, p17205) || 0,
          atanh: p17206 => Math.atanh(p17206) || 0,
          log: p17207 => Math.log(p17207) || 0,
          exp: p17208 => Math.exp(p17208) || 0,
          pow: (p17209, p17210) => Math.pow(p17209, p17210) || 0,
          abs: p17211 => Math.abs(p17211) || 0,
          round: p17212 => Math.round(p17212) || 0,
          floor: p17213 => Math.floor(p17213) || 0,
          ceil: p17214 => Math.ceil(p17214) || 0,
          min: (...iÍííííi) => Math.min(...iÍííííi) || 0,
          max: (...iÍiïîìì) => Math.max(...iÍiïîìì) || 0,
          hypot: (...iIiìiîí) => Math.hypot(...iIiìiîí) || 0,
          sqrt: p17215 => Math.sqrt(p17215) || 0,
          trunc: p17216 => Math.trunc(p17216) || 0,
          lerp: (p17217, p17218, p17219) => UTILS.lerp(p17217, p17218, p17219),
          toRad: p17220 => UTILS.toRad(p17220) || 0,
          toDeg: p17221 => UTILS.toDeg(p17221) || 0,
          calcPerc: (p17222, p17223) => UTILS.calcPercent(p17222, p17223) || 0,
          roundToNearest: (p17224, p17225) => UTILS.isNumber(p17224) ? UTILS.roundToNearest(p17224, p17225) || 0 : 0,
          roundDecimal: (p17226, p17227) => UTILS.isNumber(p17226) ? Math.round(p17226 * Math.pow(10, p17227 || 0)) / Math.pow(10, p17227 || 0) : 0
        },
        getDist2D: (p17228, p17229, p17230, p17231) => UTILS.getDistance(p17228, p17229, p17230, p17231) || 0,
        getDist3D: (p17232, p17233, p17234, p17235, p17236, p17237) => UTILS.getD3D(p17232, p17233, p17234, p17235, p17236, p17237) || 0,
        anglDst: (p17238, p17239) => UTILS.getAngleDst(p17238, p17239) || 0,
        getDir2D: (p17240, p17241, p17242, p17243) => UTILS.getDir(p17240, p17241, p17242, p17243) || 0,
        getDir3D: function (p17244, p17245, p17246, p17247, p17248, p17249) {
          var v13739 = UTILS.getDrs({
            x: p17244,
            y: p17245,
            z: p17246
          }, {
            x: p17247,
            y: p17248,
            z: p17249
          });
          return {
            get x() {
              return v13739[0] + Math.PI / 2;
            },
            get y() {
              return v13739[1];
            }
          };
        },
        randInt: (p17250, p17251) => UTILS.randInt(p17250, p17251) || 0,
        randFloat: (p17252, p17253) => UTILS.randFloat(p17252, p17253) || 0,
        hexFromHue: p17254 => UTILS.hexFromHue(p17254) || "#ffffff",
        invertHex: p17255 => UTILS.invertHex(p17255) || "#ffffff",
        RGBtoHEX: function (p17256, p17257, p17258) {
          p17256 = UTILS.isNumber(p17256) ? p17256 : 0;
          p17257 = UTILS.isNumber(p17257) ? p17257 : 0;
          p17258 = UTILS.isNumber(p17258) ? p17258 : 0;
          return UTILS.rgbToHex(p17256, p17257, p17258);
        },
        HEXtoRGB: function (p17259) {
          p17259 = UTILS.isHexColor(p17259) ? p17259 : "#ffffff";
          const v13740 = UTILS.hexToRGB(p17259);
          return {
            r: v13740[0] || 0,
            g: v13740[1] || 0,
            b: v13740[2] || 0
          };
        },
        toLower: p17260 => UTILS.toLower(p17260 + "") || "",
        toUpper: p17261 => UTILS.toUpper(p17261 + "") || "",
        truncateTxt: (p17262, p17263, p17264, p17265) => {
          p17265 = Math.abs(UTILS.isNumber(p17265) ? p17265 : 0);
          return UTILS.truncateText(p17262 + "", p17263, !!p17264, p17265) || "";
        },
        replaceText: (p17266, p17267, p17268) => UTILS.replaceText(p17266 + "", p17267 + "", p17268 + "") || "",
        textContains: (p17269, p17270) => UTILS.textContains(p17269 + "", p17270 + ""),
        copyToClipboard: p17271 => UTILS.copyToClipboard(p17271 + "")
      },
      RAYCAST: {
        from: function (p17272, p17273, p17274, p17275, p17276, p17277) {
          var vLN02521 = 0;
          var v13741 = null;
          var v13742 = p17277 * Math.sin(p17275 + Math.PI) * Math.cos(p17276);
          var v13743 = p17277 * Math.cos(p17275 + Math.PI) * Math.cos(p17276);
          var v13744 = p17277 * Math.sin(p17276);
          var v13745 = v13690.set(v13742, v13744, v13743).normalize();
        },
        fromPlayer: function () {}
      },
      TIME: {
        now: function () {
          return Date.now();
        },
        fixedDelta: function () {
          return game.fixedDelta || 0;
        },
        getReadable: function (p17278) {
          return UTILS.getReadableTime(p17278) || "";
        },
        freeze: function () {
          if (!!p17043 && !game.oldGameTimer && game.gameTimer != "skip" && !(game.endTimer > 0) && game.endTimer != "inf") {
            game.oldGameTimer = game.gameTimer;
            game.gameTimer = 0;
          }
        },
        unfreeze: function () {
          if (p17043 && game.oldGameTimer && game.gameTimer != "skip" && !(game.endTimer > 0) && game.endTimer != "inf") {
            game.gameTimer = game.oldGameTimer;
            game.oldGameTimer = 0;
          }
        }
      },
      INPUTS: {
        keyDown: function (p17279) {
          if (p17043) {
            return undefined;
          } else if (game && game.controls) {
            if (UTILS.isNumber(p17279)) {
              return !!game.controls.keys[p17279];
            } else {
              return undefined;
            }
          } else {
            return undefined;
          }
        },
        mousePos: function () {
          if (p17043) {
            return undefined;
          } else if (RENDER) {
            return RENDER.tmpMouse;
          } else {
            return undefined;
          }
        },
        mousePosOverlay: function () {
          if (!p17043 && p17042) {
            var v13746 = RENDER.tmpMouse.x / window.innerWidth;
            var v13747 = RENDER.tmpMouse.y / window.innerHeight;
            return {
              x: p17042.canvas.width / p17042.scale * v13746,
              y: p17042.canvas.height / p17042.scale * v13747
            };
          }
        },
        mouseMovement: function () {
          if (p17043) {
            return undefined;
          } else if (RENDER) {
            return RENDER.tmpMouse2;
          } else {
            return undefined;
          }
        },
        freeMouse: function () {
          if (game && game.controls) {
            game.controls.forceFreeCam = true;
            document.exitPointerLock();
          }
        },
        unlockMouse: function () {
          if (game && game.controls) {
            game.controls.tmpUnlock = true;
            game.controls.enabled = false;
            game.controls.resetKeys();
            document.exitPointerLock();
          }
        },
        lockMouse: function () {
          if (game && game.controls) {
            if (game.controls.tmpUnlock) {
              game.controls.tmpUnlock = false;
            }
            game.controls.toggle(true);
          }
        },
        disableDefault: function () {
          if (!p17043 && !!game) {
            game.dontSendInputs = true;
          }
        },
        enableDefault: function () {
          if (!p17043 && !!game) {
            game.dontSendInputs = false;
          }
        }
      },
      UI: {
        getSize: function () {
          if (p17043) {
            return undefined;
          } else {
            return {
              width: window.innerWidth,
              height: window.innerHeight
            };
          }
        },
        hideCrosshair: function () {
          if (p17042) {
            p17042.disableCrosshair = true;
          }
        },
        hideDefault: function () {
          if (!p17043 && !!game && !!game.ui) {
            game.ui.hidden = true;
            gameUIHider.style.display = "none";
            fullMenHider.style.display = "none";
          }
        },
        addImage: function (p17280, p17281, p17282, p17283, p17284) {
          if (game && game.ui) {
            if (!UTILS.isString(p17284) || !p17284 || !p17284.length || p17284.toLowerCase() == "game") {
              p17284 = "customGUIHolder";
            }
            if (p17284.toLowerCase() == "menu") {
              p17284 = "MENUDIV";
            }
            let v13748 = document.getElementById(p17284);
            if (v13748 && !(vA775.indexOf(p17284) > -1)) {
              p17281 += "";
              let v13749 = document.getElementById(p17281);
              if (!v13749 && !(vA775.indexOf(p17281) > -1) && UTILS.cssCheck(p17283 || "") && (p17280 += "", p17280 = (p17280 || "").replace(/[^\d]/g, ""), p17280 && p17280.length)) {
                let v13750 = document.createElement("img");
                v13750.id = p17281;
                v13750.setAttribute("onerror", "this.onerror=null;this.src=\"./img/noimg.png\";");
                v13750.src = UTILS.userAssetsUrl("/" + p17280 + "/texture.png");
                v13750.style.display = p17282 ? "" : "none";
                v13750.style.pointerEvents = "all";
                v13750.style.cssText += p17283 || "";
                v13748.appendChild(v13750);
                v13750.addEventListener("click", function (p17285) {
                  p17285.stopPropagation();
                  p17285.cancelBubble = true;
                  if (p17285 && p17285.target && game && game.mainScript && game.mainScript.onDIVClicked) {
                    game.mainScript.onDIVClicked(p17285.target.id);
                  }
                });
                return p17281;
              }
            }
          }
        },
        addDIV: function (p17286, p17287, p17288, p17289) {
          if (game && game.ui) {
            if (!UTILS.isString(p17289) || !p17289 || !p17289.length || p17289.toLowerCase() == "game") {
              p17289 = "customGUIHolder";
            }
            if (p17289.toLowerCase() == "menu") {
              p17289 = "MENUDIV";
            }
            let v13751 = document.getElementById(p17289);
            if (v13751 && !(vA775.indexOf(p17289) > -1)) {
              p17286 += "";
              let v13752 = document.getElementById(p17286);
              if (!v13752 && !(vA775.indexOf(p17286) > -1) && UTILS.cssCheck(p17288 || "")) {
                let v13753 = document.createElement("div");
                v13753.id = p17286;
                v13753.style.display = p17287 ? "" : "none";
                v13753.style.pointerEvents = "all";
                v13753.style.cssText += p17288 || "";
                v13751.appendChild(v13753);
                v13753.addEventListener("click", function (p17290) {
                  p17290.stopPropagation();
                  p17290.cancelBubble = true;
                  if (p17290 && p17290.target && game && game.mainScript && game.mainScript.onDIVClicked) {
                    game.mainScript.onDIVClicked(p17290.target.id);
                  }
                });
                return p17286;
              }
            }
          }
        },
        moveDIV: function (p17291, p17292, p17293) {
          if (game && game.ui && UTILS) {
            if (!UTILS.isString(p17292) || !p17292 || !p17292.length || p17292.toLowerCase() == "game") {
              p17292 = "customGUIHolder";
            }
            if (p17292.toLowerCase() == "menu") {
              p17292 = "MENUDIV";
            }
            let v13754 = document.getElementById(p17292);
            if (v13754 && !(vA775.indexOf(p17292) > -1) && (p17291 += "", !(vA775.indexOf(p17291) > -1))) {
              let v13755 = document.getElementById(p17291);
              if (v13755) {
                if (!UTILS.isString(p17293) || !p17293 || !p17293.length) {
                  p17293 = null;
                }
                if (!(vA775.indexOf(p17293) > -1)) {
                  if (p17293) {
                    v13755.id = p17293;
                  }
                  UTILS.moveElement(v13755, p17292);
                  if (p17293) {
                    return p17293;
                  } else {
                    return v13755.id;
                  }
                } else {
                  return undefined;
                }
              }
            }
          }
        },
        removeDIV: function (p17294) {
          if (!p17043 && game && game.ui) {
            p17294 += "";
            let v13756 = document.getElementById(p17294);
            if (!!v13756 && !(vA775.indexOf(p17294) > -1)) {
              v13756.remove();
            }
          }
        },
        getProp: function (p17295, p17296) {
          if (!p17043 && game && game.ui) {
            p17295 += "";
            let v13757 = document.getElementById(p17295);
            if (v13757) {
              if (vA775.indexOf(p17295) > -1) {
                return undefined;
              } else if (UTILS.isString(p17296)) {
                if (UTILS.cssCheck(p17296)) {
                  return v13757.style[p17296] || "";
                } else {
                  return undefined;
                }
              } else {
                return undefined;
              }
            } else {
              return undefined;
            }
          }
        },
        updateDIV: function (p17297, p17298, p17299) {
          if (!p17043 && game && game.ui) {
            p17297 += "";
            let v13758 = document.getElementById(p17297);
            if (v13758 && !(vA775.indexOf(p17297) > -1) && UTILS.isString(p17298) && UTILS.cssCheck(p17298)) {
              if (!UTILS.isString(p17299)) {
                p17299 = "";
              }
              if (!UTILS.cssCheck(p17299)) {
                p17299 = "";
              }
              v13758.style[p17298] = p17299;
            }
          }
        },
        updateDIVText: function (p17300, p17301) {
          if (game && game.ui) {
            p17300 += "";
            let v13759 = document.getElementById(p17300);
            if (v13759 && !(vA775.indexOf(p17300) > -1)) {
              if (!UTILS.isString(p17301)) {
                p17301 = "";
              }
              for (var vLN02522 = 0; vLN02522 < vA777.length; vLN02522++) {
                if (p17301.toLowerCase().includes(vA777[vLN02522])) {
                  return;
                }
              }
              v13759.textContent = p17301;
            }
          }
        },
        getDIVText: function (p17302) {
          if (game && game.ui && (p17302 += "", !(vA775.indexOf(p17302) > -1)) && !(vA776.indexOf(p17302) > -1)) {
            let v13760 = document.getElementById(p17302);
            if (v13760) {
              return v13760.textContent || "";
            } else {
              return undefined;
            }
          }
        }
      },
      SETTINGS: {
        set: function (p17303, p17304) {
          if (game && game.settings && UTILS.isString(p17303)) {
            if (!!game.settings.list[p17303] && game.settings.list[p17303].type != "url" && game.settings.list[p17303].type != "text" && !game.settings.list[p17303].dev && !game.settings.list[p17303].kpd && !game.settings.list[p17303].verified && !game.settings.list[p17303].noMod) {
              game.settings.set(p17303, p17304, true, true, true);
            }
          }
        },
        get: function (p17305) {
          if (game && game.settings) {
            if (UTILS.isString(p17305)) {
              if (game.settings.list[p17305] && game.settings.list[p17305].type != "url" && game.settings.list[p17305].type != "text" && !game.settings.list[p17305].dev && !game.settings.list[p17305].kpd && !game.settings.list[p17305].verified && !game.settings.list[p17305].noMod) {
                return game.settings.list[p17305].val + "";
              } else {
                return undefined;
              }
            } else {
              return undefined;
            }
          } else {
            return undefined;
          }
        },
        list: function () {
          if (game && game.settings) {
            var vA779 = [];
            for (var v13761 in game.settings.list) {
              if (game.settings.list[v13761] && game.settings.list[v13761].type != "url" && game.settings.list[v13761].type != "text" && !game.settings.list[v13761].dev && !game.settings.list[v13761].kpd && !game.settings.list[v13761].verified && !game.settings.list[v13761].noMod) {
                vA779.push(v13761);
              }
            }
            return vA779;
          }
        }
      },
      OVERLAY: {
        getSize: function () {
          if (p17042) {
            return {
              width: p17042.canvas.width / p17042.scale,
              height: p17042.canvas.height / p17042.scale
            };
          } else {
            return undefined;
          }
        },
        offset: function (p17306, p17307) {
          p17042.ctx.translate(parseFloat(p17306) || 0, parseFloat(p17307) || 0);
        },
        scale: function (p17308) {
          p17308 = parseFloat(p17308) || 0;
          p17042.ctx.scale(p17308, p17308);
        },
        clear: function () {
          if (!p17042) {
            return;
          }
          let v13762 = p17042.canvas.width / p17042.scale;
          let v13763 = p17042.canvas.height / p17042.scale;
          p17042.ctx.clearRect(0, 0, v13762, v13763);
        },
        measureText: function (p17309, p17310, p17311) {
          p17310 = UTILS.isString(p17310) ? p17310 : "";
          p17309 = UTILS.isNumber(p17309) ? p17309 : 1;
          p17311 = UTILS.isString(p17311) ? p17311 : "GameFont";
          p17042.ctx.save(1);
          p17042.ctx.font = (p17309 || 10) + "px " + p17311;
          var v13764 = p17042.ctx.measureText(p17310).width;
          p17042.ctx.restore(-1);
          if (UTILS.isNumber(v13764)) {
            return v13764;
          } else {
            return 0;
          }
        },
        drawCircle: function (p17312, p17313, p17314, p17315, p17316, p17317, p17318, p17319) {
          if (p17042) {
            p17318 = UTILS.isNumber(p17318) ? p17318 : 1;
            p17317 = UTILS.isHexColor(p17317) ? p17317 : "#FFF";
            p17312 = UTILS.isNumber(p17312) ? p17312 : 0;
            p17313 = UTILS.isNumber(p17313) ? p17313 : 0;
            p17314 = UTILS.isNumber(p17314) ? p17314 : 1;
            p17315 = UTILS.isNumber(p17315) ? p17315 : 1;
            p17316 = UTILS.isNumber(p17316) ? p17316 : 0;
            p17042.ctx.save(1);
            p17042.ctx.globalAlpha = p17318;
            p17042.ctx.fillStyle = p17317;
            p17042.ctx.beginPath();
            p17042.ctx.translate(p17312, p17313);
            if (p17316) {
              p17042.ctx.rotate((p17316 || 0) * Math.PI / 180);
            }
            p17042.ctx.ellipse(p17319 ? -(p17314 / 2) : 0, p17319 ? -(p17315 / 2) : 0, p17314, p17315, 0, 0, Math.PI * 2);
            p17042.ctx.fill();
            p17042.ctx.restore(-1);
          }
        },
        drawRect: function (p17320, p17321, p17322, p17323, p17324, p17325, p17326, p17327) {
          if (p17042) {
            p17326 = UTILS.isNumber(p17326) ? p17326 : 1;
            p17325 = UTILS.isHexColor(p17325) ? p17325 : "#FFF";
            p17320 = UTILS.isNumber(p17320) ? p17320 : 0;
            p17321 = UTILS.isNumber(p17321) ? p17321 : 0;
            p17322 = UTILS.isNumber(p17322) ? p17322 : 1;
            p17323 = UTILS.isNumber(p17323) ? p17323 : 1;
            p17324 = UTILS.isNumber(p17324) ? p17324 : 0;
            p17042.ctx.save(1);
            p17042.ctx.globalAlpha = p17326;
            p17042.ctx.fillStyle = p17325;
            p17042.ctx.beginPath();
            p17042.ctx.translate(p17320, p17321);
            if (p17324) {
              p17042.ctx.rotate((p17324 || 0) * Math.PI / 180);
            }
            p17042.ctx.rect(p17327 ? -(p17322 / 2) : 0, p17327 ? -(p17323 / 2) : 0, p17322, p17323);
            p17042.ctx.fill();
            p17042.ctx.restore(-1);
          }
        },
        drawLine: function (p17328, p17329, p17330, p17331, p17332, p17333, p17334) {
          if (p17042) {
            p17334 = UTILS.isNumber(p17334) ? p17334 : 1;
            p17333 = UTILS.isHexColor(p17333) ? p17333 : "#FFF";
            p17328 = UTILS.isNumber(p17328) ? p17328 : 0;
            p17329 = UTILS.isNumber(p17329) ? p17329 : 0;
            p17330 = UTILS.isNumber(p17330) ? p17330 : 0;
            p17331 = UTILS.isNumber(p17331) ? p17331 : 0;
            p17332 = UTILS.isNumber(p17332) ? p17332 : 0;
            p17042.ctx.save(1);
            p17042.ctx.globalAlpha = p17334;
            p17042.ctx.fillStyle = p17333;
            p17042.ctx.strokeStyle = p17333;
            p17042.ctx.lineWidth = p17332;
            p17042.ctx.beginPath();
            p17042.ctx.moveTo(p17328, p17329);
            p17042.ctx.lineTo(p17330, p17331);
            p17042.ctx.stroke();
            p17042.ctx.restore(-1);
          }
        },
        drawText: function (p17335, p17336, p17337, p17338, p17339, p17340, p17341, p17342, p17343) {
          if (p17042) {
            p17335 = UTILS.isString(p17335) ? p17335 : "";
            p17342 = UTILS.isNumber(p17342) ? p17342 : 1;
            p17341 = UTILS.isHexColor(p17341) ? p17341 : "#FFF";
            p17336 = UTILS.isNumber(p17336) ? p17336 : 0;
            p17337 = UTILS.isNumber(p17337) ? p17337 : 0;
            p17338 = UTILS.isNumber(p17338) ? p17338 : 0;
            p17339 = UTILS.isNumber(p17339) ? p17339 : 1;
            p17340 = UTILS.isString(p17340) ? p17340 : null;
            p17343 = UTILS.isString(p17343) ? p17343 : "GameFont";
            p17042.ctx.save(1);
            p17042.ctx.globalAlpha = p17342;
            p17042.ctx.fillStyle = p17341;
            p17042.ctx.beginPath();
            p17042.ctx.translate(p17336, p17337);
            if (p17338) {
              p17042.ctx.rotate((p17338 || 0) * Math.PI / 180);
            }
            p17042.ctx.font = (p17339 || 10) + "px " + p17343;
            p17042.ctx.textBaseline = "middle";
            if (p17340) {
              p17042.ctx.textAlign = p17340;
            }
            p17042.ctx.fillStyle = p17341;
            p17042.ctx.fillText(p17335, 0, 0);
            p17042.ctx.restore(-1);
          }
        },
        drawImage: function (p17344, p17345, p17346, p17347, p17348, p17349, p17350) {
          if (p17042 && UTILS) {
            p17344 = UTILS.isNumber(p17344) ? p17344 : 0;
            p17350 = UTILS.isNumber(p17350) ? p17350 : 1;
            p17345 = UTILS.isNumber(p17345) ? p17345 : 0;
            p17346 = UTILS.isNumber(p17346) ? p17346 : 0;
            p17347 = UTILS.isNumber(p17347) ? p17347 : 1;
            p17348 = UTILS.isNumber(p17348) ? p17348 : 1;
            p17349 = UTILS.isNumber(p17349) ? p17349 : 0;
            p17042.ctx.save(1);
            p17042.ctx.globalAlpha = p17350;
            let v13765 = p17042.HELPER.loadImg(UTILS.userAssetsUrl(p17344 + "/texture.png"));
            if (v13765.isReady) {
              p17042.ctx.translate(p17345, p17346);
              if (p17349) {
                p17042.ctx.rotate((p17349 || 0) * Math.PI / 180);
              }
              p17042.ctx.drawImage(v13765, -(p17347 / 2), -(p17348 / 2), p17347, p17348);
            }
            p17042.ctx.restore(-1);
          }
        },
        beginPath: function () {
          if (p17042 && UTILS) {
            p17042.ctx.beginPath();
          }
        },
        closePath: function () {
          if (p17042 && UTILS) {
            p17042.ctx.closePath();
          }
        },
        save: function () {
          if (p17042 && UTILS) {
            p17042.ctx.save(1);
          }
        },
        restore: function () {
          if (p17042 && UTILS) {
            p17042.ctx.restore(-1);
          }
        },
        translate: function (p17351, p17352) {
          if (p17042 && UTILS) {
            p17351 = UTILS.isNumber(p17351) ? p17351 : 0;
            p17352 = UTILS.isNumber(p17352) ? p17352 : 0;
            p17042.ctx.translate(p17351, p17352);
          }
        },
        transform: function (p17353, p17354, p17355, p17356, p17357, p17358) {
          if (p17042 && UTILS) {
            p17353 = UTILS.isNumber(p17353) ? p17353 : 0;
            p17354 = UTILS.isNumber(p17354) ? p17354 : 0;
            p17355 = UTILS.isNumber(p17355) ? p17355 : 0;
            p17356 = UTILS.isNumber(p17356) ? p17356 : 0;
            p17357 = UTILS.isNumber(p17357) ? p17357 : 0;
            p17358 = UTILS.isNumber(p17358) ? p17358 : 0;
            p17042.ctx.transform(p17353, p17354, p17355, p17356, p17357, p17358);
          }
        },
        setTransform: function (p17359, p17360, p17361, p17362, p17363, p17364) {
          if (p17042 && UTILS) {
            p17359 = UTILS.isNumber(p17359) ? p17359 : 0;
            p17360 = UTILS.isNumber(p17360) ? p17360 : 0;
            p17361 = UTILS.isNumber(p17361) ? p17361 : 0;
            p17362 = UTILS.isNumber(p17362) ? p17362 : 0;
            p17363 = UTILS.isNumber(p17363) ? p17363 : 0;
            p17364 = UTILS.isNumber(p17364) ? p17364 : 0;
            p17042.ctx.setTransform(p17359, p17360, p17361, p17362, p17363, p17364);
          }
        },
        moveTo: function (p17365, p17366) {
          if (p17042 && UTILS) {
            p17365 = UTILS.isNumber(p17365) ? p17365 : 0;
            p17366 = UTILS.isNumber(p17366) ? p17366 : 0;
            p17042.ctx.moveTo(p17365, p17366);
          }
        },
        lineTo: function (p17367, p17368) {
          if (p17042 && UTILS) {
            p17367 = UTILS.isNumber(p17367) ? p17367 : 0;
            p17368 = UTILS.isNumber(p17368) ? p17368 : 0;
            p17042.ctx.lineTo(p17367, p17368);
          }
        },
        fill: function () {
          if (p17042 && UTILS) {
            p17042.ctx.fill();
          }
        },
        fillStyle: function (p17369) {
          if (p17042 && UTILS) {
            p17369 = UTILS.isHexColor(p17369) ? p17369 : "#FFF";
            p17042.ctx.fillStyle = p17369;
          }
        },
        stroke: function () {
          if (p17042 && UTILS) {
            p17042.ctx.stroke();
          }
        },
        strokeText: function (p17370, p17371, p17372, p17373) {
          if (p17042 && UTILS) {
            p17370 = UTILS.isString(p17370) ? p17370 : "";
            p17371 = UTILS.isNumber(p17371) ? p17371 : 0;
            p17372 = UTILS.isNumber(p17372) ? p17372 : 0;
            p17373 = UTILS.isNumber(p17373) ? p17373 : undefined;
            p17042.ctx.strokeText(p17370, p17371, p17372, p17373);
          }
        },
        strokeRect: function (p17374, p17375, p17376, p17377) {
          if (p17042 && UTILS) {
            p17374 = UTILS.isNumber(p17374) ? p17374 : 0;
            p17375 = UTILS.isNumber(p17375) ? p17375 : 0;
            p17376 = UTILS.isNumber(p17376) ? p17376 : 0;
            p17377 = UTILS.isNumber(p17377) ? p17377 : 0;
            p17042.ctx.strokeRect(p17374, p17375, p17376, p17377);
          }
        },
        strokeStyle: function (p17378) {
          if (p17042 && UTILS) {
            p17378 = UTILS.isHexColor(p17378) ? p17378 : "#FFF";
            p17042.ctx.strokeStyle = p17378;
          }
        },
        lineWidth: function (p17379) {
          if (p17042 && UTILS) {
            p17379 = UTILS.isNumber(p17379) ? p17379 : 0;
            p17042.ctx.lineWidth = p17379;
          }
        },
        lineDashOffset: function (p17380) {
          if (p17042 && UTILS) {
            p17380 = UTILS.isNumber(p17380) ? p17380 : 0;
            p17042.ctx.lineWidth = p17380;
          }
        },
        lineJoin: function (p17381) {
          if (p17042 && UTILS) {
            if (["bevel", "round", "miter"].indexOf(p17381) > -1) {
              p17042.ctx.lineJoin = p17381;
            }
          }
        },
        ellipse: function (p17382, p17383, p17384, p17385, p17386, p17387, p17388, p17389) {
          if (p17042 && UTILS) {
            p17382 = UTILS.isNumber(p17382) ? p17382 : 0;
            p17383 = UTILS.isNumber(p17383) ? p17383 : 0;
            p17384 = Math.abs(UTILS.isNumber(p17384) ? p17384 : 0);
            p17385 = Math.abs(UTILS.isNumber(p17385) ? p17385 : 0);
            p17386 = UTILS.isNumber(p17386) ? p17386 : 0;
            p17387 = UTILS.isNumber(p17387) ? p17387 : 0;
            p17388 = UTILS.isNumber(p17388) ? p17388 : 0;
            p17389 = !!p17389;
            p17042.ctx.ellipse(p17382, p17383, p17384, p17385, p17386, p17387, p17388, p17389);
          }
        },
        arc: function (p17390, p17391, p17392, p17393, p17394, p17395) {
          if (p17042 && UTILS) {
            p17390 = UTILS.isNumber(p17390) ? p17390 : 0;
            p17391 = UTILS.isNumber(p17391) ? p17391 : 0;
            p17392 = Math.abs(UTILS.isNumber(p17392) ? p17392 : 0);
            p17393 = UTILS.isNumber(p17393) ? p17393 : 0;
            p17394 = UTILS.isNumber(p17394) ? p17394 : 0;
            p17395 = !!p17395;
            p17042.ctx.arc(p17390, p17391, p17392, p17393, p17394, p17395);
          }
        },
        arcTo: function (p17396, p17397, p17398, p17399, p17400) {
          if (p17042 && UTILS) {
            p17396 = UTILS.isNumber(p17396) ? p17396 : 0;
            p17397 = UTILS.isNumber(p17397) ? p17397 : 0;
            p17398 = UTILS.isNumber(p17398) ? p17398 : 0;
            p17399 = UTILS.isNumber(p17399) ? p17399 : 0;
            p17400 = Math.abs(UTILS.isNumber(p17400) ? p17400 : 0);
            p17042.ctx.arcTo(p17396, p17397, p17398, p17399, p17400);
          }
        },
        bezierCurveTo: function (p17401, p17402, p17403, p17404, p17405, p17406) {
          if (p17042 && UTILS) {
            p17401 = UTILS.isNumber(p17401) ? p17401 : 0;
            p17402 = UTILS.isNumber(p17402) ? p17402 : 0;
            p17403 = UTILS.isNumber(p17403) ? p17403 : 0;
            p17404 = UTILS.isNumber(p17404) ? p17404 : 0;
            p17405 = UTILS.isNumber(p17405) ? p17405 : 0;
            p17406 = UTILS.isNumber(p17406) ? p17406 : 0;
            p17042.ctx.bezierCurveTo(p17401, p17402, p17403, p17404, p17405, p17406);
          }
        },
        quadraticCurveTo: function (p17407, p17408, p17409, p17410) {
          if (p17042 && UTILS) {
            p17407 = UTILS.isNumber(p17407) ? p17407 : 0;
            p17408 = UTILS.isNumber(p17408) ? p17408 : 0;
            p17409 = UTILS.isNumber(p17409) ? p17409 : 0;
            p17410 = UTILS.isNumber(p17410) ? p17410 : 0;
            p17042.ctx.quadraticCurveTo(p17407, p17408, p17409, p17410);
          }
        },
        globalAlpha: function (p17411) {
          if (p17042 && UTILS) {
            p17411 = UTILS.isNumber(p17411) ? p17411 : 0;
            p17042.ctx.globalAlpha = p17411;
          }
        }
      },
      STORAGE: {
        set: function (p17412, p17413, p17414, p17415) {
          if (p17043 && game) {
            p17414 = p17414 == "global" ? p17414 : "private";
            if (f2121("str_set_" + p17412)) {
              f2125("storage.set already in progress for " + p17412);
              return;
            } else if (f2124("str_set_" + p17412, 1)) {
              f2125("Calling storage.set too much");
              f2122("str_set_" + p17412);
              return;
            } else {
              game.storageUpdt(p17412, p17413, 0, p17414, function (p17416, p17417) {
                f2122("str_set_" + p17412);
                if (p17417) {
                  f2125(p17417);
                }
                if (p17415 && typeof p17415 == "function") {
                  if (p17416 && p17416.length && !p17417) {
                    var vO446 = {};
                    for (var vLN02523 = 0; vLN02523 < p17416.length; vLN02523++) {
                      vO446[v13689(p17416[vLN02523].mk + "")] = p17416[vLN02523].mv + "";
                    }
                    p17415(vO446, true, p17412);
                  } else {
                    p17415({}, false, p17412);
                  }
                }
              });
              return;
            }
          }
        },
        update: function (p17418, p17419, p17420, p17421) {
          if (p17043 && game) {
            p17420 = p17420 == "global" ? p17420 : "private";
            if (f2121("str_upd_" + p17418)) {
              f2125("storage.update already in progress for " + p17418);
              return;
            } else if (f2124("str_upd_" + p17418, 1)) {
              f2125("Calling storage.update too much");
              f2122("str_upd_" + p17418);
              return;
            } else {
              game.storageUpdt(p17418, p17419, 3, p17420, function (p17422, p17423) {
                f2122("str_upd_" + p17418);
                if (p17423) {
                  f2125(p17423);
                }
                if (p17421 && typeof p17421 == "function") {
                  if (p17422 && p17422.length && !p17423) {
                    var vO447 = {};
                    for (var vLN02524 = 0; vLN02524 < p17422.length; vLN02524++) {
                      vO447[v13689(p17422[vLN02524].mk + "")] = p17422[vLN02524].mv + "";
                    }
                    p17421(vO447, true, p17418);
                  } else {
                    p17421({}, false, p17418);
                  }
                }
              });
              return;
            }
          }
        },
        transact: function (p17424, p17425, p17426, p17427) {
          return f2125("Transactions disabled for now");
        },
        load: function (p17428, p17429, p17430) {
          if (p17043 && game) {
            if (p17430 && typeof p17430 == "function") {
              if (p17429 == "") {
                p17429 = null;
              } else {
                p17429 += "";
              }
              if (f2121("str_lod_" + p17428)) {
                f2125("storage.load already in progress for " + p17428);
                return;
              } else {
                game.getStoragePlayer(p17428, p17429, function (p17431, p17432) {
                  f2122("str_lod_" + p17428);
                  if (p17432) {
                    f2125(p17432);
                  } else if (p17431 && p17431.length) {
                    var vO448 = {};
                    for (var vLN02525 = 0; vLN02525 < p17431.length; vLN02525++) {
                      vO448[v13689(p17431[vLN02525].mk + "")] = p17431[vLN02525].kv + "";
                    }
                    p17430(vO448, true, p17428);
                  } else {
                    f2125("No data");
                  }
                });
                return;
              }
            } else {
              f2125("Missing callback");
              return;
            }
          }
        }
      },
      COOKIES: {
        save: function (p17433, p17434) {
          if (!p17043) {
            if (UTILS && game && game.customMapData) {
              p17433 = UTILS.isString(p17433) ? p17433 : "";
              if (p17433.length && (UTILS.isString(p17434) || UTILS.isNumber(p17434) || typeof p17434 == Boolean || Array.isArray(p17434))) {
                p17433 = "krkcst_" + game.customMapData.id + "_" + p17433;
                UTILS.saveVal(p17433, p17434);
              }
            }
          }
        },
        remove: function (p17435) {
          if (!p17043) {
            if (UTILS && game && game.customMapData) {
              p17435 = UTILS.isString(p17435) ? p17435 : "";
              if (p17435.length) {
                p17435 = "krkcst_" + game.customMapData.id + "_" + p17435;
                UTILS.deleteVal(p17435);
              }
            }
          }
        },
        load: function (p17436) {
          if (p17043) {
            return "";
          } else if (UTILS && game) {
            if (game.customMapData) {
              p17436 = UTILS.isString(p17436) ? p17436 : "";
              if (!p17436.length) {
                return "";
              } else {
                p17436 = "krkcst_" + game.customMapData.id + "_" + p17436;
                return UTILS.getSavedVal(p17436) + "";
              }
            } else {
              return "";
            }
          } else {
            return "";
          }
        },
        has: function (p17437) {
          return !p17043 && !!UTILS && !!game && !!game.customMapData && (p17437 = UTILS.isString(p17437) ? p17437 : "", !!p17437.length) && (p17437 = "krkcst_" + game.customMapData.id + "_" + p17437, !!UTILS.hasSavedVal(p17437));
        }
      },
      SOUND: {
        stop: function (p17438) {
          if (p17048) {
            p17438 = UTILS.isNumber(p17438) ? p17438 : 0;
            p17048.stop(p17438, true);
          }
        },
        play2D: function (p17439, p17440, p17441, p17442) {
          if (p17048 && !f2123("p_snd2D", 10)) {
            p17439 = parseInt(p17439);
            p17439 = UTILS.isNumber(p17439) ? p17439 : 0;
            p17440 = UTILS.isNumber(p17440) ? p17440 : 1;
            p17441 = UTILS.isNumber(p17441) ? p17441 : 0;
            p17442 = !!p17442;
            var v13766 = p17048.play(p17439, p17440, p17442, p17441, true);
            var vO449 = {
              sound: v13766[0],
              id: v13766[1],
              aid: p17439,
              vol: p17440,
              rate: p17441,
              loop: p17442
            };
            return vO444.sound(vO449);
          }
        },
        play3D: function (p17443, p17444, p17445, p17446, p17447, p17448, p17449) {
          if (p17048 && !f2123("p_snd3D", 10)) {
            p17443 = parseInt(p17443);
            p17443 = UTILS.isNumber(p17443) ? p17443 : 0;
            p17445 = UTILS.isNumber(p17445) ? p17445 : 0;
            p17446 = UTILS.isNumber(p17446) ? p17446 : 0;
            p17447 = UTILS.isNumber(p17447) ? p17447 : 0;
            p17444 = UTILS.isNumber(p17444) ? p17444 : 1;
            p17448 = UTILS.isNumber(p17448) ? p17448 : 0;
            p17449 = !!p17449;
            var v13767 = p17048[p17449 ? "play3DL" : "play3D"](p17443, p17445, p17446, p17447, p17444, p17448, 25, 1, true, 0);
            var vO450 = {
              sound: v13767[0],
              id: v13767[1],
              aid: p17443,
              vol: p17444,
              x: p17445,
              y: p17446,
              z: p17447,
              rate: p17448,
              loop: p17449
            };
            return vO444.sound(vO450);
          }
        }
      },
      ANIM: {
        playClip: function () {},
        stopClip: function () {}
      },
      CAMERA: {
        get envZone() {
          if (RENDER) {
            if (RENDER.lastEnvId == null) {
              return -1;
            } else {
              return RENDER.lastEnvId;
            }
          } else {
            return -1;
          }
        },
        detach: function () {
          if (RENDER) {
            game.detachedCam = true;
          }
        },
        attach: function () {
          if (RENDER) {
            game.detachedCam = false;
          }
        },
        move: function (p17450, p17451, p17452) {
          if (game && game.controls) {
            p17450 = UTILS.isNumber(p17450) ? p17450 : 0;
            p17451 = UTILS.isNumber(p17451) ? p17451 : 0;
            p17452 = UTILS.isNumber(p17452) ? p17452 : 0;
            game.controls.moveCam(p17450, p17451, p17452);
          }
        },
        rotate: function (p17453, p17454, p17455) {
          if (game && game.controls) {
            p17453 = UTILS.isNumber(p17453) ? p17453 : 0;
            p17454 = UTILS.isNumber(p17454) ? p17454 : 0;
            p17455 = UTILS.isNumber(p17455) ? p17455 : 0;
            game.controls.rotateCam(p17453, p17454, p17455);
          }
        },
        lookAt: function (p17456, p17457, p17458) {
          if (RENDER && game && game.controls) {
            p17456 = UTILS.isNumber(p17456) ? p17456 : 0;
            p17457 = UTILS.isNumber(p17457) ? p17457 : 0;
            p17458 = UTILS.isNumber(p17458) ? p17458 : 0;
            var v13768 = game.controls.object.position.x - p17456;
            var v13769 = game.controls.object.position.y - p17457;
            var v13770 = game.controls.object.position.z - p17458;
            var v13771 = Math.sqrt(v13768 * v13768 + v13770 * v13770);
            var v13772 = -Math.atan2(v13769, v13771);
            var v13773 = -Math.atan2(-v13768, v13770);
            game.controls.object.rotation.y = v13773 || 0;
            game.controls.pchObjc.rotation.x = v13772 || 0;
            RENDER.camera.rotation.set(0, 0, 0);
            RENDER.camera.position.set(0, 0, 0);
            RENDER.camera.updateProjectionMatrix();
            RENDER.updateFrustum();
          }
        },
        shake: function (p17459) {
          if (RENDER) {
            p17459 = UTILS.isNumber(p17459) ? p17459 : 0;
            RENDER.shake(p17459);
          }
        },
        fov: function (p17460) {
          if (RENDER) {
            p17460 = UTILS.isNumber(p17460) ? p17460 : 0;
            RENDER.camera.fov = p17460;
            RENDER.camera.updateProjectionMatrix();
          }
        },
        getObj: function () {
          return {
            get id() {
              return RENDER.camera.id;
            }
          };
        },
        position: {
          get x() {
            if (game && game.controls) {
              return game.controls.object.position.x;
            } else {
              return 0;
            }
          },
          set x(p17461) {
            if (game && game.controls) {
              game.controls.object.position.x = parseFloat(p17461) || 0;
            }
          },
          get y() {
            if (game && game.controls) {
              return game.controls.object.position.y;
            } else {
              return 0;
            }
          },
          set y(p17462) {
            if (game && game.controls) {
              game.controls.object.position.y = parseFloat(p17462) || 0;
            }
          },
          get z() {
            if (game && game.controls) {
              return game.controls.object.position.z;
            } else {
              return 0;
            }
          },
          set z(p17463) {
            if (game && game.controls) {
              game.controls.object.position.z = parseFloat(p17463) || 0;
            }
          }
        },
        rotation: {
          get x() {
            if (game && game.controls) {
              return game.controls.object.rotation.x;
            } else {
              return 0;
            }
          },
          set x(p17464) {
            if (game && game.controls) {
              game.controls.object.rotation.x = parseFloat(p17464) || 0;
            }
          },
          get y() {
            if (game && game.controls) {
              return game.controls.object.rotation.y;
            } else {
              return 0;
            }
          },
          set y(p17465) {
            if (game && game.controls) {
              game.controls.object.rotation.y = parseFloat(p17465) || 0;
            }
          },
          get z() {
            if (game && game.controls) {
              return game.controls.object.rotation.z;
            } else {
              return 0;
            }
          },
          set z(p17466) {
            if (game && game.controls) {
              game.controls.object.rotation.z = parseFloat(p17466) || 0;
            }
          }
        }
      },
      SCENE: {
        posToScreen: function (p17467, p17468, p17469) {
          if (RENDER) {
            p17467 = UTILS.isNumber(p17467) ? p17467 : 0;
            p17468 = UTILS.isNumber(p17468) ? p17468 : 0;
            p17469 = UTILS.isNumber(p17469) ? p17469 : 0;
            var v13774 = RENDER.getTmpVector(p17467, p17468, p17469);
            var v13775 = RENDER.frustum.containPoint(v13774);
            v13774.project(RENDER.camera);
            return {
              get onScreen() {
                return v13775;
              },
              get x() {
                return p17042.canvas.width / p17042.scale * ((v13774.x + 1) / 2);
              },
              get y() {
                return p17042.canvas.height / p17042.scale * (1 - (v13774.y + 1) / 2);
              }
            };
          }
        },
        clear: function () {
          if (RENDER) {
            while (RENDER.scene.children.length > 0) {
              RENDER.scene.remove(RENDER.scene.children[0]);
            }
          }
        },
        setFog: function (p17470, p17471) {
          if (RENDER) {
            p17470 = UTILS.isHexColor(p17470) ? p17470 : RENDER.scene.fog.color.getHex();
            p17471 = UTILS.isNumber(p17471) ? p17471 : RENDER.scene.far;
            p17471 = UTILS.limitMM(p17471, 10, 15000);
            RENDER.scene.fog = new RENDER.THREE.Fog(p17470, 1, p17471);
          }
        },
        setAmbientLight: function (p17472, p17473) {
          if (RENDER && RENDER.ambientLight) {
            p17472 = UTILS.isHexColor(p17472) ? p17472 : RENDER.ambientLight.color.getHex();
            p17473 = UTILS.isNumber(p17473) ? parseFloat(p17473) : RENDER.ambientLight.intensity;
            p17473 = UTILS.limitMM(p17473, 0.1, 3).round(2);
            RENDER.ambientLight.color = new RENDER.THREE.Color(p17472);
            RENDER.ambientLight.intensity = p17473;
          }
        },
        setSkyLight: function (p17474, p17475, p17476, p17477, p17478) {
          if (RENDER) {
            p17474 = UTILS.isHexColor(p17474) ? p17474 : RENDER.skyLight.color.getHex();
            p17475 = UTILS.isNumber(p17475) ? parseFloat(p17475) : RENDER.skyLight.intensity;
            p17475 = UTILS.limitMM(p17475, 0.1, 3).round(2);
            p17476 = UTILS.isNumber(p17476) ? p17476 : config.sunAngleX;
            p17476 = Math.PI * (UTILS.limitMM(p17476, 0, 360) / -180);
            p17477 = UTILS.isNumber(p17477) ? p17477 : config.sunAngleY;
            p17477 = Math.PI * (UTILS.limitMM(p17477, 0, 360) / -180);
            p17478 = UTILS.isNumber(p17478) ? p17478 : config.lightDistance;
            p17478 = UTILS.limitMM(p17478, 10, 15000);
            RENDER.skyLight.position.x = p17478 * Math.cos(p17476);
            RENDER.skyLight.position.y = p17478 * Math.sin(p17476) * Math.sin(p17477);
            RENDER.skyLight.position.z = p17478 * Math.sin(p17476) * Math.cos(p17477);
            RENDER.skyLight.color = new RENDER.THREE.Color(p17474);
            RENDER.skyLight.intensity = p17475;
          }
        },
        setSkyColor: function (p17479) {
          if (RENDER) {
            p17479 = UTILS.isHexColor(p17479) ? p17479 : "#dce8ed";
            RENDER.renderer.setClearColor(p17479);
          }
        },
        setSkyDome: function (p17480, p17481, p17482, p17483) {
          if (RENDER) {
            p17483 = p17483 || {};
            if (!UTILS.isObject(p17483)) {
              p17483 = {};
            }
            var vParseInt54 = parseInt(p17483[v13689("texture")]);
            var vParseInt55 = parseInt(p17483[v13689("emissiveTexture")]);
            var vO451 = {
              skyDomeCol0: UTILS.isHexColor(p17480) ? p17480 : "#fff",
              skyDomeCol1: UTILS.isHexColor(p17481) ? p17481 : "#fff",
              skyDomeCol2: UTILS.isHexColor(p17482) ? p17482 : "#fff",
              skyDomeTex: !!UTILS.isNumber(vParseInt54),
              skyDomeTexA: UTILS.isNumber(vParseInt54) ? vParseInt54 : null,
              skyDomeEmisTex: UTILS.isNumber(vParseInt55) ? vParseInt55 : null,
              skyDomeEmis: UTILS.isHexColor(p17483[v13689("emissive")]) ? p17483[v13689("emissive")] : null,
              skyDomeMovT: UTILS.isNumber(p17483[v13689("textureMoveSpeed")]) ? p17483[v13689("textureMoveSpeed")] : undefined,
              skyDomeMovD: p17483[v13689("textureMoveAxis")] == "x" ? 0 : p17483[v13689("textureMoveAxis")] == "y" ? 1 : UTILS.limitMM(parseInt(p17483[v13689("textureMoveAxis")]) || 0, 0, 1)
            };
            RENDER.clearSkyDome();
            RENDER.skyDomeInit(vO451);
          }
        },
        removeSkyDome: function () {
          if (RENDER) {
            RENDER.clearSkyDome();
          }
        },
        addCustom: function (p17484, p17485, p17486, p17487, p17488, p17489, p17490, p17491, p17492, p17493) {
          if (RENDER && (p17485 = UTILS.isHexColor(p17485) ? p17485 : "#FFF", p17487 = UTILS.isNumber(p17487) ? p17487 : 0, p17488 = UTILS.isNumber(p17488) ? p17488 : 0, p17489 = UTILS.isNumber(p17489) ? p17489 : 0, p17490 = UTILS.isNumber(p17490) ? p17490 : 1, p17491 = UTILS.isNumber(p17491) ? p17491 : 1, p17492 = UTILS.isNumber(p17492) ? p17492 : 1, Array.isArray(p17486) && p17486.length)) {
            p17486 = p17486.map(Number).filter(p17494 => UTILS.isNumber(p17494));
            p17493 = p17493 || {};
            if (!UTILS.isObject(p17493)) {
              p17493 = {};
            }
            p17493[v13689("aid")] = p17484;
            var v13776 = vO445.obj({
              src: "default",
              colr: p17485 || "#fff",
              scale: 1,
              noEmisTex: true,
              vertexColors: true
            }, p17493);
            var v13777 = new RENDER.THREE.BufferGeometry();
            v13777.setAttribute("position", new RENDER.THREE.BufferAttribute(new Float32Array(p17486), 3));
            RENDER.GEOS.colorize(v13777, v13776.colr);
            v13777 = RENDER.THREE.BufferGeometryUtils.mergeVertices(v13777);
            var v13778 = new RENDER.THREE.Mesh(v13777);
            RENDER.moveMesh(v13778, p17487, p17488, p17489);
            v13778.scale.set(p17490, p17491, p17492);
            RENDER.add(v13778, v13776);
            return vO444.obj3D(v13778, v13776);
          }
        },
        addCube: function (p17495, p17496, p17497, p17498, p17499, p17500, p17501, p17502, p17503) {
          if (RENDER) {
            p17496 = UTILS.isHexColor(p17496) ? p17496 : "#FFF";
            p17497 = UTILS.isNumber(p17497) ? p17497 : 0;
            p17498 = UTILS.isNumber(p17498) ? p17498 : 0;
            p17499 = UTILS.isNumber(p17499) ? p17499 : 0;
            p17500 = UTILS.isNumber(p17500) ? p17500 : 1;
            p17501 = UTILS.isNumber(p17501) ? p17501 : 1;
            p17502 = UTILS.isNumber(p17502) ? p17502 : 1;
            p17503 = p17503 || {};
            if (!UTILS.isObject(p17503)) {
              p17503 = {};
            }
            p17503[v13689("aid")] = p17495;
            var v13779 = vO445.obj({
              src: "default",
              colr: p17496 || "#fff",
              scale: 1,
              noEmisTex: true,
              vertexColors: true
            }, p17503);
            var v13780 = new RENDER.THREE.Mesh(RENDER.GEOS.generateCube(null, p17500, p17501, p17502, v13779));
            RENDER.moveMesh(v13780, p17497, p17498, p17499);
            v13780.scale.set(p17500, p17501, p17502);
            RENDER.add(v13780, v13779);
            return vO444.obj3D(v13780, v13779);
          }
        },
        addPlane: function (p17504, p17505, p17506, p17507, p17508, p17509, p17510, p17511) {
          if (RENDER) {
            p17505 = UTILS.isHexColor(p17505) ? p17505 : "#FFF";
            p17506 = UTILS.isNumber(p17506) ? p17506 : 0;
            p17507 = UTILS.isNumber(p17507) ? p17507 : 0;
            p17508 = UTILS.isNumber(p17508) ? p17508 : 0;
            p17509 = UTILS.isNumber(p17509) ? p17509 : 1;
            p17510 = UTILS.isNumber(p17510) ? p17510 : 1;
            p17511 = p17511 || {};
            if (!UTILS.isObject(p17511)) {
              p17511 = {};
            }
            p17511[v13689("aid")] = p17504;
            var v13781 = vO445.obj({
              src: "default",
              colr: p17505 || "#fff",
              noEmisTex: true,
              vertexColors: true,
              scale: 1,
              side: 2
            }, p17511, 1);
            var v13782 = new RENDER.THREE.Mesh(RENDER.GEOS.generatePlane(p17510, p17509, v13781, p17506, p17507, p17508));
            RENDER.moveMesh(v13782, p17506, p17507, p17508);
            v13782.scale.set(p17509, p17510, 1);
            RENDER.add(v13782, v13781);
            return vO444.obj3D(v13782, v13781);
          }
        },
        addSphere: function (p17512, p17513, p17514, p17515, p17516, p17517, p17518, p17519, p17520) {
          if (RENDER) {
            p17513 = UTILS.isHexColor(p17513) ? p17513 : "#FFF";
            p17514 = UTILS.isNumber(p17514) ? p17514 : 0;
            p17515 = UTILS.isNumber(p17515) ? p17515 : 0;
            p17516 = UTILS.isNumber(p17516) ? p17516 : 0;
            p17517 = UTILS.isNumber(p17517) ? p17517 : 1;
            p17518 = UTILS.isNumber(p17518) ? p17518 : 1;
            p17519 = UTILS.isNumber(p17519) ? p17519 : 1;
            p17520 = p17520 || {};
            if (!UTILS.isObject(p17520)) {
              p17520 = {};
            }
            p17520[v13689("aid")] = p17512;
            var v13783 = vO445.obj({
              src: "default",
              colr: p17513 || "#fff",
              noEmisTex: true,
              vertexColors: true,
              scale: 1,
              side: 2
            }, p17520);
            var v13784 = new RENDER.THREE.Mesh(RENDER.GEOS.generateSphere(p17517, p17518, p17519, v13783));
            RENDER.moveMesh(v13784, p17514, p17515 + p17518 / 2, p17516);
            v13784.scale.set(p17517, p17518, p17519);
            RENDER.add(v13784, v13783);
            return vO444.obj3D(v13784, v13783);
          }
        },
        addAsset: function (p17521, p17522, p17523, p17524, p17525, p17526, p17527, p17528) {
          if (RENDER) {
            if (!p17528 || typeof p17528 != "function") {
              p17528 = undefined;
            }
            p17521 += "";
            p17526 = UTILS.isHexColor(p17526) ? p17526 : "#FFF";
            p17522 = UTILS.isNumber(p17522) ? p17522 : 0;
            p17523 = UTILS.isNumber(p17523) ? p17523 : 0;
            p17524 = UTILS.isNumber(p17524) ? p17524 : 0;
            p17525 = UTILS.isNumber(p17525) ? p17525 : 1;
            p17525 = UTILS.limitMM(p17525, 0.01, 100).round(2);
            var v13785 = (p17521 || "").includes("e");
            var v13786 = (p17521 || "").includes("n");
            var v13787 = (p17521 || "").includes("s");
            var v13788 = (p17521 || "").includes("a");
            var v13789 = (p17521 || "").includes("m");
            var v13790 = (p17521 || "").includes("r");
            var v13791 = (p17521 || "").includes("l");
            var v13792 = (p17521 || "").includes("p");
            var v13793 = (p17521 || "").includes("b");
            var v13794 = (p17521 || "").includes("g");
            var v13795 = (p17521 || "").includes("q");
            var v13796 = (p17521 || "").includes("f");
            if (!v13794 && !v13795) {
              p17523 += p17525;
            }
            p17523 += UTILS.randFloat(-0.01, 0.01);
            var v13797 = (p17521 || "").replace(/[^\d]/g, "");
            p17527 = p17527 || {};
            if (!UTILS.isObject(p17527)) {
              p17527 = {};
            }
            var v13798 = vO445.obj({
              isMdl: true,
              fileExt: v13795 ? "glb" : v13794 ? "gltf" : v13796 ? "fbx" : null,
              src: v13797 + "/model",
              emissive: v13785 ? "#ffffff" : null,
              vertexColors: true,
              color: p17526,
              normal: v13786,
              spec: v13787,
              alphaTest: v13788 ? 0.02 : 0,
              asset: v13797,
              metalness: v13789 ? 1 : 0,
              roughness: v13790 ? 1 : 0,
              lightM: v13791 ? 1 : 0,
              uv2: !!v13791 || undefined,
              displacement: v13792 ? 1 : 0,
              bump: v13793 ? 1 : 0
            }, p17527, 2);
            var v13799 = RENDER[v13794 || v13795 || v13796 ? "loadAnimMesh" : "loadMesh"](v13798, p17522, p17523, p17524, 0, p17525, RENDER.scene, false, p17528);
            return vO444.obj3D(v13799, v13798);
          }
        },
        addSprite: function (p17529, p17530, p17531, p17532, p17533, p17534, p17535, p17536, p17537) {
          if (RENDER) {
            p17530 = UTILS.isHexColor(p17530) ? p17530 : "#FFF";
            p17531 = UTILS.isNumber(p17531) ? p17531 : 0;
            p17532 = UTILS.isNumber(p17532) ? p17532 : 0;
            p17533 = UTILS.isNumber(p17533) ? p17533 : 0;
            p17534 = UTILS.isNumber(p17534) ? p17534 : 1;
            p17535 = UTILS.isNumber(p17535) ? p17535 : 1;
            p17536 = UTILS.isNumber(p17536) ? p17536 : 1;
            p17537 = p17537 || {};
            if (!UTILS.isObject(p17537)) {
              p17537 = {};
            }
            p17537[v13689("aid")] = p17529;
            var v13800 = vO445.obj({
              src: "default",
              colr: p17530 || "#fff",
              noEmisTex: true,
              vertexColors: true,
              scale: 1,
              side: 2,
              mat: RENDER.THREE.SpriteMaterial
            }, p17537);
            var v13801 = new RENDER.THREE.Sprite();
            RENDER.moveMesh(v13801, p17531, p17532, p17533);
            v13801.scale.set(p17534, p17536, 1);
            RENDER.add(v13801, v13800);
            return vO444.obj3D(v13801, v13800);
          }
        },
        addPointLight: function (p17538, p17539, p17540, p17541, p17542, p17543, p17544, p17545) {
          if (RENDER && !(RENDER.lighting < 2)) {
            p17538 = UTILS.isHexColor(p17538) ? p17538 : "#f2f8fc";
            p17539 = UTILS.isNumber(p17539) ? p17539 : 0;
            p17540 = UTILS.isNumber(p17540) ? p17540 : 0;
            p17541 = UTILS.isNumber(p17541) ? p17541 : 0;
            p17542 = UTILS.isNumber(p17542) ? p17542 : 0;
            p17542 = UTILS.limitMM(p17542, 0, 1000);
            p17543 = UTILS.isNumber(p17543) ? p17543 : 1;
            p17543 = UTILS.limitMM(p17543, 0.1, 2);
            p17544 = UTILS.isNumber(p17544) ? p17544 : 1;
            p17544 = UTILS.limitMM(p17544, 0, 15);
            var v13802 = new RENDER.THREE.PointLight(p17538, p17544, p17542, p17543);
            v13802.castShadow = !!p17545;
            v13802.position.set(p17539, p17540, p17541);
            v13802.traverse(function (p17546) {
              p17546.layers.enable(1);
            });
            RENDER.add(v13802);
            return vO444.obj3D(v13802);
          }
        },
        addDirLight: function (p17547, p17548, p17549, p17550, p17551, p17552, p17553, p17554, p17555) {
          if (RENDER && RENDER.lighting == 3) {
            p17547 = UTILS.isHexColor(p17547) ? p17547 : "#f2f8fc";
            p17548 = UTILS.isNumber(p17548) ? p17548 : 0;
            p17549 = UTILS.isNumber(p17549) ? p17549 : 0;
            p17550 = UTILS.isNumber(p17550) ? p17550 : 0;
            p17551 = UTILS.isNumber(p17551) ? p17551 : 0;
            p17552 = UTILS.isNumber(p17552) ? p17552 : 0;
            p17553 = UTILS.isNumber(p17553) ? p17553 : 0;
            p17554 = UTILS.isNumber(p17554) ? p17554 : 1;
            p17554 = UTILS.limitMM(p17554, 0, 15);
            var v13803 = new RENDER.THREE.DirectionalLight(p17547, p17554);
            v13803.castShadow = !!p17555;
            v13803.position.set(p17548, p17549, p17550);
            v13803.target.position.set(p17551, p17552, p17553);
            v13803.traverse(function (p17556) {
              p17556.layers.enable(1);
            });
            RENDER.add(v13803);
            RENDER.add(v13803.target);
            return vO444.obj3D(v13803);
          }
        },
        addSpotLight: function (p17557, p17558, p17559, p17560, p17561, p17562, p17563, p17564, p17565, p17566, p17567, p17568, p17569) {
          if (RENDER) {
            p17557 = UTILS.isHexColor(p17557) ? p17557 : "#f2f8fc";
            p17558 = UTILS.isNumber(p17558) ? p17558 : 0;
            p17559 = UTILS.isNumber(p17559) ? p17559 : 0;
            p17560 = UTILS.isNumber(p17560) ? p17560 : 0;
            p17561 = UTILS.isNumber(p17561) ? p17561 : 0;
            p17562 = UTILS.isNumber(p17562) ? p17562 : 0;
            p17563 = UTILS.isNumber(p17563) ? p17563 : 0;
            p17564 = UTILS.isNumber(p17564) ? p17564 : 0;
            p17564 = UTILS.limitMM(p17564, 0, 1000);
            p17565 = UTILS.isNumber(p17565) ? p17565 : 1;
            p17565 = UTILS.limitMM(p17565, 0.1, 2);
            p17566 = UTILS.isNumber(p17566) ? p17566 : 1;
            p17566 = UTILS.limitMM(p17566, 0, 15);
            p17567 = UTILS.isNumber(p17567) ? p17567 : 45;
            p17567 = UTILS.limitMM(p17567, 1, 90);
            p17567 = UTILS.toRad(p17567);
            p17568 = UTILS.isNumber(p17568) ? p17568 : 0;
            p17568 = UTILS.limitMM(p17568, 0, 1);
            var v13804 = new RENDER.THREE.SpotLight(p17557, p17566, p17564, p17567, p17568, p17565);
            v13804.castShadow = !!p17569;
            v13804.position.set(p17558, p17559, p17560);
            v13804.target.position.set(p17561, p17562, p17563);
            v13804.traverse(function (p17570) {
              p17570.layers.enable(1);
            });
            RENDER.add(v13804);
            RENDER.add(v13804.target);
            return vO444.obj3D(v13804);
          }
        },
        addRectLight: function (p17571, p17572, p17573, p17574, p17575, p17576, p17577) {
          if (RENDER && RENDER.lighting == 3) {
            p17571 = UTILS.isHexColor(p17571) ? p17571 : "#f2f8fc";
            p17572 = UTILS.isNumber(p17572) ? p17572 : 0;
            p17573 = UTILS.isNumber(p17573) ? p17573 : 0;
            p17574 = UTILS.isNumber(p17574) ? p17574 : 0;
            p17575 = UTILS.isNumber(p17575) ? p17575 : 1;
            p17576 = UTILS.isNumber(p17576) ? p17576 : 1;
            p17577 = UTILS.isNumber(p17577) ? p17577 : 1;
            p17577 = UTILS.limitMM(p17577, 0, 15);
            if (!RENDER.hasInitRectArea) {
              RENDER.hasInitRectArea = true;
              RENDER.THREE.RectAreaLightUniformsLib.init();
            }
            var v13805 = new RENDER.THREE.RectAreaLight(p17571, p17577, p17575, p17576);
            RENDER.moveMesh(v13805, p17572, p17573, p17574);
            v13805.traverse(function (p17578) {
              p17578.layers.enable(1);
            });
            RENDER.add(v13805);
            return vO444.obj3D(v13805);
          }
        },
        addSign: function (p17579, p17580, p17581, p17582, p17583, p17584, p17585) {
          if (RENDER) {
            p17584 = UTILS.isString(p17584) ? p17584 : "Hello World";
            p17579 = UTILS.isNumber(p17579) ? p17579 : 0;
            p17580 = UTILS.isNumber(p17580) ? p17580 : 0;
            p17581 = UTILS.isNumber(p17581) ? p17581 : 0;
            p17582 = UTILS.isNumber(p17582) ? p17582 : 1;
            p17583 = UTILS.isNumber(p17583) ? p17583 : 1;
            p17585 = p17585 || {};
            if (!UTILS.isObject(p17585)) {
              p17585 = {};
            }
            var v13806 = vO445.sign({
              text: p17584,
              transparent: true,
              vertexColors: true,
              renderVisD: 400,
              noGroup: true,
              side: RENDER.THREE.DoubleSide,
              noShader: true,
              alphaTest: 0.02,
              depthWrite: true
            }, p17585, p17582, p17583);
            var v13807 = v13806.mimicSprite ? new RENDER.THREE.Sprite() : new RENDER.THREE.Mesh(RENDER.GEOS.generatePlane(p17583, p17582, v13806, p17579, p17580, p17581));
            RENDER.moveMesh(v13807, p17579, p17580, p17581);
            v13807.scale.set(p17582, p17583, 1);
            RENDER.add(v13807, v13806);
            return vO444.obj3D(v13807, v13806);
          }
        },
        addLightCone: function (p17586, p17587, p17588, p17589, p17590, p17591, p17592, p17593) {
          if (RENDER) {
            p17586 = UTILS.isHexColor(p17586) ? p17586 : "#FFF";
            p17587 = UTILS.isNumber(p17587) ? p17587 : 0;
            p17588 = UTILS.isNumber(p17588) ? p17588 : 0;
            p17589 = UTILS.isNumber(p17589) ? p17589 : 0;
            p17590 = UTILS.isNumber(p17590) ? p17590 : 1;
            p17591 = UTILS.isNumber(p17591) ? p17591 : 1;
            p17592 = UTILS.isNumber(p17592) ? p17592 : 1;
            p17593 = p17593 || {};
            if (!UTILS.isObject(p17593)) {
              p17593 = {};
            }
            delete p17593[v13689("aid")];
            var v13808 = vO445.obj({
              src: "lightcone_" + (p17593[v13689("fullCone")] == null ? 0 : 1),
              colr: p17586 || "#fff",
              noEmisTex: true,
              depthWrite: false,
              vertexColors: true,
              scale: 1,
              shadows: false,
              side: 2,
              blending: RENDER.THREE.AdditiveBlending,
              mat: RENDER.THREE.MeshBasicMaterial
            }, p17593, 3);
            var v13809 = new RENDER.THREE.Mesh(RENDER.GEOS.generateCone(p17592, p17593));
            v13809.scale.set(p17590 / 2, p17592, p17591 / 2);
            RENDER.moveMesh(v13809, p17587, p17588, p17589);
            RENDER.add(v13809, v13808);
            return vO444.obj3D(v13809, v13808);
          }
        },
        addLightBar: function (p17594, p17595, p17596, p17597, p17598, p17599, p17600) {
          if (RENDER) {
            p17594 = UTILS.isHexColor(p17594) ? p17594 : "#FFF";
            p17595 = UTILS.isNumber(p17595) ? p17595 : 0;
            p17596 = UTILS.isNumber(p17596) ? p17596 : 0;
            p17597 = UTILS.isNumber(p17597) ? p17597 : 0;
            p17598 = UTILS.isNumber(p17598) ? p17598 : 1;
            p17599 = UTILS.isNumber(p17599) ? p17599 : 1;
            p17600 = p17600 || {};
            if (!UTILS.isObject(p17600)) {
              p17600 = {};
            }
            delete p17600[v13689("aid")];
            p17600[v13689("forceTransparency")] = true;
            var v13810 = vO445.obj({
              src: "lightcone_1",
              colr: p17594 || "#fff",
              noEmisTex: true,
              vertexColors: true,
              scale: 1,
              side: 2
            }, p17600, 1);
            var v13811 = v13810.mimicSprite ? new RENDER.THREE.Sprite() : new RENDER.THREE.Mesh(RENDER.GEOS.generatePlane(p17599, p17598, v13810, p17595, p17596, p17597));
            RENDER.moveMesh(v13811, p17595, p17596, p17597);
            v13811.scale.set(p17598, p17599, 1);
            RENDER.add(v13811, v13810);
            return vO444.obj3D(v13811, v13810);
          }
        },
        movObj: function (p17601, p17602, p17603, p17604) {
          if (RENDER && p17601 && p17601[v13689("position")]) {
            p17601[v13689("position")].x += parseFloat(p17602) || 0;
            p17601[v13689("position")].y += parseFloat(p17603) || 0;
            p17601[v13689("position")].z += parseFloat(p17604) || 0;
          }
        },
        rotObj: function (p17605, p17606, p17607, p17608) {
          if (RENDER && p17605 && p17605[v13689("rotation")]) {
            p17605[v13689("rotation")].x = parseFloat(p17606) || 0;
            p17605[v13689("rotation")].y = parseFloat(p17607) || 0;
            p17605[v13689("rotation")].z = parseFloat(p17608) || 0;
          }
        },
        scaleObj: function (p17609, p17610, p17611, p17612) {
          if (RENDER && p17609 && p17609[v13689("scale")]) {
            p17609[v13689("scale")].x = parseFloat(p17610) || 0;
            p17609[v13689("scale")].y = parseFloat(p17611) || 0;
            p17609[v13689("scale")].z = parseFloat(p17612) || 0;
          }
        }
      },
      PAYMENTS: {
        giveKR: function (p17613, p17614) {
          if (p17043 && game && game.krRewards) {
            p17614 = UTILS.isNumber(p17614) ? p17614 : 0;
            if (!(p17614 <= 0) && !f2123("p_givKR", 4)) {
              game.rewardKR(p17613, p17614 || 0);
            }
          }
        },
        charge: function () {}
      },
      PLAYERS: {
        getSelf: function () {
          if (p17043) {
            return null;
          } else if (game && game.controls) {
            if (game.tmpPlayer) {
              return vO444.player(game.tmpPlayer);
            } else {
              return null;
            }
          } else {
            return null;
          }
        },
        toggleLOD: function (p17615) {
          if (!p17043 && !!game) {
            game.useLOD = !!p17615;
          }
        },
        disableMeshes: function () {
          if (!p17043 && !!game) {
            game.disableMeshes = true;
          }
        },
        list: function () {
          return game.players.list.map(vO444.player);
        },
        findByID: function (p17616) {
          var v13812 = null;
          for (var vLN02526 = 0; vLN02526 < game.players.list.length; ++vLN02526) {
            if (game.players.list[vLN02526].id == p17616) {
              v13812 = game.players.list[vLN02526];
              break;
            }
          }
          if (v13812) {
            return vO444.player(v13812);
          } else {
            return null;
          }
        }
      },
      AI: {
        spawn: function (p17617, p17618, p17619, p17620, p17621, p17622) {
          if (p17043) {
            p17622 = p17622 || {};
            if (!UTILS.isObject(p17622)) {
              p17622 = {};
            }
            var vO452 = {
              asset: p17617,
              src: "model",
              actions: null,
              chance: null,
              constE: null,
              eventN: null,
              interface: null,
              interfaceT: null,
              singleUse: null
            };
            vO452.respawnT = parseFloat(p17622[v13689("respawnT")]) || 0;
            vO452.respawnR = !!p17622[v13689("respawnR")];
            vO452.targAI = !!p17622[v13689("targAI")];
            vO452.targPlr = !!p17622[v13689("targPlr")];
            vO452.friendly = !!p17622[v13689("friendly")];
            vO452 = vO445.AI(vO452, p17622);
            var v13813 = game.AI.spawn(null, 0, p17618, p17619, p17620, p17621, vO452);
            return vO444.AI(v13813);
          }
        },
        remove: function (p17623) {
          if (p17043) {
            var v13814 = game.AI.findBySid(p17623);
            if (v13814) {
              game.AI.removeFully(v13814);
            }
          }
        },
        list: function () {
          if (p17043) {
            return game.AI.ais.map(vO444.AI);
          } else {
            return undefined;
          }
        }
      },
      TRIGGERS: {
        list: function () {},
        execute: function (p17624, ...iÏìíîíi) {}
      },
      OBJECTS: {
        getPathNodes: function () {
          if (!game || !game.map || !game.map.manager) {
            return [];
          }
          var vA780 = [];
          for (var v13815 in game.map.manager.pathNodes) {
            vA780.push(vO444.node(game.map.manager.pathNodes[v13815]));
          }
          return vA780;
        },
        list: function () {
          if (!game || !game.map || !game.map.manager) {
            return [];
          }
          var vA781 = [];
          for (var vLN02527 = 0; vLN02527 < game.map.manager.objects.length; vLN02527++) {
            vA781.push(vO444.obj3DServ(game.map.manager.objects[vLN02527]));
          }
          return vA781;
        }
      },
      ADS: {
        playVideo: function () {
          if (!p17043) {
            window.forceVideoAd();
          }
        }
      },
      MODS: {
        load: function (p17625) {
          if (!p17043 && !!UTILS.isString(p17625) && !f2123("loadmd", 2)) {
            window.loadModPack(p17625, true);
          }
        },
        reset: function () {
          if (!p17043) {
            window.windows[3].reset();
          }
        }
      },
      ADMIN: {
        kick: function (p17626) {
          if (p17043 && p17044 && game) {
            var v13816 = game.players.list.find(p17627 => p17627.id == p17626);
            if (v13816) {
              var v13817 = v13816.account && v13816.account.isDev;
              if (v13817) {
                return;
              }
              v13816.kicked = true;
              v13816.send("error", "Kicked by host");
              if (p17044.sockets[v13816.id]) {
                p17044.sockets[v13816.id].close();
              }
            }
          }
        },
        ban: function (p17628) {
          if (p17043 && p17044 && game) {
            var v13818 = game.players.list.find(p17629 => p17629.id == p17628);
            if (v13818) {
              var v13819 = v13818.account && v13818.account.isDev;
              if (v13819) {
                return;
              }
              v13818.banned = true;
              v13818.send("error", "Banned");
              if (p17044.sockets[v13818.id] && p17044.sockets[v13818.id].remoteAddress) {
                game.banList.push(p17044.sockets[v13818.id].remoteAddress);
              }
              if (p17044.sockets[v13818.id]) {
                p17044.sockets[v13818.id].close();
              }
            }
          }
        }
      },
      PLATFORM: {
        isClient: function () {
          return !p17043 && !!window.isDeskCli;
        },
        isBrowser: function () {
          return !p17043 && !!game && !!game.ui && !game.ui.isMobileControls && !window.isDeskCli;
        },
        isMobile: function () {
          return !p17043 && !!game && !!game.ui && !!game.ui.isMobileControls;
        }
      },
      CONFIG: {
        getHost: function () {
          if (!p17043) {
            return null;
          }
          if (!p17044) {
            return null;
          }
          if (!game) {
            return null;
          }
          var v13820 = game.host;
          if (!v13820) {
            return null;
          }
          var v13821 = game.players.findById(v13820);
          if (v13821) {
            return vO444.player(v13821);
          } else {
            return null;
          }
        },
        getMatch: function () {},
        getSettings: function () {},
        getWeapons: function () {},
        getClasses: function () {}
      }
    },
    types: require("./krunkScriptTypes.js"),
    alias: {
      UTILS: "UTILS",
      Math: "UTILS.math"
    }
  };
};